(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["blog-list"] && !Shopify.designMode) return;
  try {
    
(function () {
  // 窄屏时 pill 排是横向滚动的，高亮那颗可能在视野外。把它滚进来，
  // 但只滚这个容器自己 —— scrollIntoView 会连带把整个页面往下带。
  function reveal(root) {
    var strip = root.querySelector('.bl__pills');
    var active = root.querySelector('[data-bl-active]');
    if (!strip || !active) return;
    if (strip.scrollWidth <= strip.clientWidth) return;
    strip.scrollLeft = active.offsetLeft - strip.clientWidth / 2 + active.offsetWidth / 2;
  }

  function bootAll(scope) {
    (scope || document).querySelectorAll('[data-bl-root]').forEach(reveal);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { bootAll(); });
  } else {
    bootAll();
  }

  document.addEventListener('shopify:section:load', function (e) { bootAll(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["brand-tab-block"] && !Shopify.designMode) return;
  try {
    
    class BrandsTab extends HTMLElement {
        constructor() {
            super();
            this.tabTitle = this.querySelector('.tab-title');
            this.tabContent = this.querySelector('.tab-panel-content');
            const ele = this.querySelectorAll('[tab-title-action]');
            const actionLoadMore = this.querySelectorAll('[data-load-more-block]');
            this.widthWindow = 0;
            if (ele.length) {
                ele.forEach((button) => button.addEventListener('click', this.onActive.bind(this)));
            }
            if (actionLoadMore.length) {
                actionLoadMore.forEach((button) => button.addEventListener('click', this.onLoadMore.bind(this)));
            }
        }

        onActive(e) {
            this.tabTitle.querySelector('.active').classList.remove('active');
            this.tabContent.querySelector('.active').classList.remove('active');
            this.querySelector(e.target.dataset.target).classList.add('active');
            e.target.parentElement.classList.add('active');
        }
        onLoadMore(e) {
            this.resize();
            if (this.widthWindow > 1024) {
                var eleHide = (e.target.parentElement).querySelectorAll('.hidden-lg');
                var _number = e.target.dataset.rowlg;
                var _class = 'hidden-lg';
                
            } else if(this.widthWindow > 551) {
                var eleHide = (e.target.parentElement).querySelectorAll('.hidden-md');
                var _number = 9;
                var _class = 'hidden-md';
            } else {
                var eleHide = (e.target.parentElement).querySelectorAll('.hidden-sm');
                var _number = 6;
                var _class = 'hidden-sm';
            }
            if (eleHide.length) {
                // let number_show = (eleHide.length > number ? number : eleHide.length);
                if (e.target.classList.contains('more')) {
                    for (let i = 0; i < eleHide.length; i++) {
                        eleHide[i].classList.remove('show');
                    }
                    e.target.querySelector('span').textContent = e.target.dataset.buttonmore;
                    e.target.classList.remove('more');
                } else {
                    for (let i = 0; i < eleHide.length; i++) {
                        eleHide[i].classList.add('show');
                    }
                    e.target.querySelector('span').textContent = e.target.dataset.buttonless;
                    e.target.classList.add('more');
                }

                // (eleHide.length > _number ? '' : e.target.classList.add('hidden'));
            }
        }
        resize() {
            this.widthWindow = window.innerWidth;
        }
    }
    customElements.define('brand-tab', BrandsTab);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-categories"] && !Shopify.designMode) return;
  try {
    
(function () {
  var filterParam = 'filter.p.m.custom.product_tier';
  function initCategoryCollapse() {
    document.querySelectorAll('.mcc').forEach(function (root) {
      var grid = root.querySelector('.mcc__grid');
      var button = root.querySelector('.mcc__more');
      if (!grid || !button) return;
      function measure() {
        root.removeAttribute('data-mobile-collapse');
        var cards = Array.from(grid.children);
        cards.forEach(function (card) { card.removeAttribute('data-extra-row'); });
        if (!window.matchMedia('(max-width:1024px)').matches || getComputedStyle(grid).display !== 'grid') {
          button.hidden = true;
          return;
        }
        var rows = [];
        cards.forEach(function (card) {
          var top = card.offsetTop;
          if (rows.indexOf(top) === -1) rows.push(top);
          if (rows.indexOf(top) >= 2) card.setAttribute('data-extra-row', '');
        });
        button.hidden = rows.length <= 2;
        root.setAttribute('data-mobile-collapse', '');
      }
      if (root.hasAttribute('data-collapse-ready')) return;
      root.setAttribute('data-collapse-ready', '');
      button.addEventListener('click', function () {
        var expanded = root.classList.toggle('is-expanded');
        button.setAttribute('aria-expanded', String(expanded));
        button.textContent = expanded ? '− Less' : '+ More';
      });
      var previousWidth;
      new ResizeObserver(function (entries) {
        var width = entries[0].contentRect.width;
        if (width !== previousWidth) { previousWidth = width; measure(); }
      }).observe(grid);
      window.addEventListener('resize', measure);
      measure();
    });
  }
  initCategoryCollapse();
  document.addEventListener('shopify:section:load', initCategoryCollapse);

  function syncBuilderRangeState() {
    var selected = new URL(window.location.href).searchParams.getAll(filterParam).indexOf('Builder Range') !== -1;
    document.querySelectorAll('[data-mcc-builder-range]').forEach(function (card) {
      card.classList.toggle('is-selected', selected);
      if (selected) card.setAttribute('aria-current', 'page');
      else card.removeAttribute('aria-current');
    });
  }

  syncBuilderRangeState();
  window.addEventListener('popstate', syncBuilderRangeState);
  document.addEventListener('shopify:section:load', syncBuilderRangeState);

  new MutationObserver(function (mutations) {
    var collectionUpdated = mutations.some(function (mutation) {
      return Array.prototype.some.call(mutation.addedNodes, function (node) {
        return node.nodeType === 1 && (node.matches('[data-cp-root]') || node.querySelector('[data-cp-root]'));
      });
    });
    if (collectionUpdated) syncBuilderRangeState();
  }).observe(document.body, { childList: true, subtree: true });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-header"] && !Shopify.designMode) return;
  try {
    
(function () {
  function measureBreadcrumb(root) {
    var crumbs = root.querySelector('.mch__crumbs');
    if (!crumbs || !crumbs.querySelector(':scope > .mch__parent')) return;
    crumbs.classList.remove('is-collapsed');
    var menu = crumbs.querySelector('details');
    if (menu) menu.open = false;
    if (root.clientWidth > 900) return;
    var items = Array.from(crumbs.children).filter(function (item) {
      return getComputedStyle(item).display !== 'none';
    });
    var needed = items.reduce(function (sum, item) {
      return sum + Math.max(item.scrollWidth, item.getBoundingClientRect().width);
    }, 0) + (parseFloat(getComputedStyle(crumbs).columnGap) || 0) * Math.max(0, items.length - 1);
    crumbs.classList.toggle('is-collapsed', crumbs.querySelectorAll(':scope > .mch__parent').length > 1 || needed > crumbs.clientWidth + 1);
  }
  function measure(root) {
    var wrap = root.querySelector('[data-mch-description-wrap]');
    var text = root.querySelector('[data-mch-description]');
    var button = root.querySelector('[data-mch-more]');
    if (!wrap || !text || !button) return;

    wrap.classList.remove('is-collapsible', 'is-expanded');
    button.hidden = true;
    button.setAttribute('aria-expanded', 'false');

    var fullHeight = text.scrollHeight;
    wrap.classList.add('is-collapsible');
    var collapsedHeight = text.getBoundingClientRect().height;
    if (fullHeight > collapsedHeight + 2) button.hidden = false;
    else wrap.classList.remove('is-collapsible');
  }

  function boot(scope) {
    (scope || document).querySelectorAll('[data-mch-root]').forEach(function (root) {
      measure(root);
      measureBreadcrumb(root);
      if (root.dataset.mchBound) return;
      root.dataset.mchBound = 'true';
      new ResizeObserver(function () { measureBreadcrumb(root); }).observe(root);
      var wrap = root.querySelector('[data-mch-description-wrap]');
      var button = root.querySelector('[data-mch-more]');
      if (!wrap || !button) return;
      button.addEventListener('click', function () {
        var expanded = wrap.classList.toggle('is-expanded');
        button.setAttribute('aria-expanded', expanded ? 'true' : 'false');
        var label = button.querySelector('[data-mch-more-label]');
        if (label) label.textContent = expanded ? button.dataset.expandedLabel : button.dataset.collapsedLabel;
      });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); });
  else boot();
  document.addEventListener('shopify:section:load', function (event) { boot(event.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ctl-range-bundle"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  function makeMoney(currency) {
    var nf = new Intl.NumberFormat(document.documentElement.lang || 'en-AU', {
      style: 'currency', currency: currency || 'AUD',
      minimumFractionDigits: 0, maximumFractionDigits: 2
    });
    return function (cents) { return nf.format(cents / 100).replace(/^[A-Z]{1,2}\$/, '$'); };
  }

  /* ── 选项值归一化与匹配 ─────────────────────────── */
  function norm(s) {
    return String(s || '').toLowerCase().trim()
      .replace(/[-_/]/g, ' ')
      .replace(/\s+/g, ' ')
      .replace(/\bmatt\b/g, 'matte')       // Matt Black / Matte Black
      .replace(/\bbrush\b/g, 'brushed')
      .replace(/\bs\/steel\b/g, 'stainless steel');
  }

  function loose(a, b) {
    if (a.length < 3 || b.length < 3) return false;
    return a.indexOf(b) > -1 || b.indexOf(a) > -1;
  }

  // 打分：同名选项精确匹配 3 分，同名模糊 1 分；名称对不上时跨名比对
  function bestOption(select, ctx) {
    var names = (select.dataset.optNames || '').split('|').map(norm);
    var best = null, bestScore = 0;

    Array.prototype.forEach.call(select.options, function (o) {
      if (o.disabled) return;
      var vals = (o.dataset.optValues || '').split('|').map(norm);
      var score = 0;

      names.forEach(function (n, i) {
        if (!ctx[n] || !vals[i]) return;
        if (ctx[n] === vals[i]) score += 3;
        else if (loose(ctx[n], vals[i])) score += 1;
      });

      if (score === 0) {
        Object.keys(ctx).forEach(function (k) {
          vals.forEach(function (val) {
            if (ctx[k] === val) score += 2;
            else if (loose(ctx[k], val)) score += 1;
          });
        });
      }

      if (score > bestScore) { bestScore = score; best = o; }
    });

    // 阈值 2：弱匹配不覆盖商家设定的默认变体
    return bestScore >= 2 ? best : null;
  }

  /* ── 购物车刷新 ─────────────────────────────────────
     1) cartSectionIds()  探测页面上与购物车相关的 section
     2) swapSections()    把服务端重渲染的 HTML 换进 DOM
     3) notifyTheme()     广播主题可能监听的事件
     4) openCartDrawer()  打开抽屉（这一步最依赖主题，见下方注释）
  ─────────────────────────────────────────────────── */
  var CART_RE = /cart|basket|minicart/i;

  function cartSectionIds() {
    var ids = [];
    document.querySelectorAll('[id^="shopify-section-"]').forEach(function (el) {
      var id = el.id.replace('shopify-section-', '');
      if (CART_RE.test(id) && ids.indexOf(id) === -1) ids.push(id);
    });
    return ids;
  }

  function swapSections(map) {
    var done = [];
    if (!map) return done;
    Object.keys(map).forEach(function (id) {
      var host = document.getElementById('shopify-section-' + id);
      if (!host || !map[id]) return;
      var doc = new DOMParser().parseFromString(map[id], 'text/html');
      var inner = doc.getElementById('shopify-section-' + id);
      host.innerHTML = inner ? inner.innerHTML : map[id];
      done.push(id);
    });
    return done;
  }

  /* innerHTML 替换会销毁主题绑在旧节点上的直接事件监听器（jQuery .on(el)）。
     广播 shopify:section:load 让主题重新初始化——OS2.0 主题普遍监听这个事件，
     Ella 的 jQuery 侧也一并 trigger 一次。 */
  function reinitSections(ids) {
    ids.forEach(function (id) {
      var host = document.getElementById('shopify-section-' + id);
      var detail = { sectionId: id, load: host };
      document.dispatchEvent(new CustomEvent('shopify:section:load', { bubbles: true, detail: detail }));
      if (host) host.dispatchEvent(new CustomEvent('shopify:section:load', { bubbles: true, detail: detail }));
      if (window.jQuery) window.jQuery(document).trigger('shopify:section:load', [detail]);
    });
  }

  // 抽屉不是 OS2.0 section 时的兜底：重新拉当前页，只换抽屉节点
  var DRAWER_SEL = 'cart-drawer,#CartDrawer,.cart-drawer,#mini-cart,.mini-cart,#sidebar-cart';
  var COUNT_SEL = '[data-cart-count],.cart-count,.cart-count-bubble,.header-cart__count,.site-header__cart-count';

  function softRefreshCart() {
    return fetch(window.location.href, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var done = false;
        var fresh = doc.querySelector(DRAWER_SEL), live = document.querySelector(DRAWER_SEL);
        if (fresh && live) { live.innerHTML = fresh.innerHTML; done = true; }
        var fc = doc.querySelector(COUNT_SEL), lc = document.querySelector(COUNT_SEL);
        if (fc && lc) { lc.innerHTML = fc.innerHTML; done = true; }
        return done;
      })
      .catch(function () { return false; });
  }

  /* Shopify.onCartUpdate 默认是遗留桩函数——弹 alert("There are now N items in the cart.")，
     本意是让主题覆盖它。Ella 并没有覆盖，所以直接调会弹原生对话框。
     这里检测函数体，只有在主题真的覆盖过之后才使用。

     另外两个 Ella 全局的真实用途，别搞错：
       getCartUpdate(line, quantity, cb)  改数量/删除，POST /cart/change.js，不是刷新
       postCart()                          Crisp 的购物车同步，与主题渲染无关 */
  function isLegacyStub(fn) {
    try {
      return /There are now|items in the cart/i.test(Function.prototype.toString.call(fn));
    } catch (e) { return true; }
  }

  function themeCartRefresh() {
    var fn = window.Shopify && window.Shopify.onCartUpdate;
    if (typeof fn !== 'function' || isLegacyStub(fn)) return null;
    return fetch(window.Shopify.routes.root + 'cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { fn(cart); return true; })
      .catch(function () { return false; });
  }

  // Crisp 的购物车同步，任何刷新路径之后都该调一次
  function syncCrisp() {
    if (typeof window.postCart === 'function') { try { window.postCart(); } catch (e) {} }
  }

  // 主题可能已经自己把抽屉打开了，避免我们再点一次把它关掉
  var OPEN_RE = /(^|\s)(is-open|is-active|active|open|drawer-open|js-drawer-open|cart-open|show)(\s|$)/;
  function drawerIsOpen() {
    var el = document.querySelector(DRAWER_SEL);
    if (el && OPEN_RE.test(el.className)) return true;
    return OPEN_RE.test(document.body.className) || OPEN_RE.test(document.documentElement.className);
  }

  function notifyTheme(items, data) {
    var detail = { items: items, cart: data };
    ['ctl:added', 'cart:refresh', 'cart:updated', 'cart:build', 'ajaxCart:afterCartLoad']
      .forEach(function (n) {
        document.dispatchEvent(new CustomEvent(n, { bubbles: true, detail: detail }));
      });
    // Ella 6.x 基于 jQuery，原生 CustomEvent 触发不到 jQuery 监听器
    if (window.jQuery) {
      ['cart:refresh', 'cart:updated', 'ajaxCart:afterCartLoad']
        .forEach(function (n) { window.jQuery(document).trigger(n, [data]); });
    }
  }

  function openCartDrawer() {
    // 先点主题的购物车触发器：委托绑定（$(document).on）在 DOM 替换后仍然有效，
    // 而抽屉节点上的直接绑定已经随 innerHTML 一起没了。
    var trigger = document.querySelector(
      '[data-cart-drawer-toggle],[data-action="open-cart"],.js-drawer-open-right,' +
      '.site-header__cart,.header-cart,.cart-icon-bubble,a[href$="/cart"][data-drawer]'
    );
    if (trigger) { trigger.click(); return true; }

    var el = document.querySelector(DRAWER_SEL);
    if (el && typeof el.open === 'function') { el.open(); return true; }
    return false;
  }

  function prependSelfCard(root) {
    var tpl = root.querySelector('template[data-ctl-self]');
    if (!tpl || !tpl.content || !tpl.content.firstElementChild) return;
    var track = root.querySelector('[data-ctl-track]');
    var id = tpl.content.firstElementChild.getAttribute('data-ctl-self-card');
    // 推荐结果理论上不含当前商品，保险起见去重
    if (id && track.querySelector('[data-ctl-card][data-ctl-self-card="' + id + '"]')) return;
    track.insertBefore(tpl.content.cloneNode(true), track.firstChild);
  }

  /* ── 绑定一个已填充好的 root ─────────────────────── */
  function init(root) {
    if (root.dataset.ctlReady === '1') return;

    var track = root.querySelector('[data-ctl-track]');
    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-ctl-card]'));

    if (!track.querySelector('.ctl-card')) { bail(root, 'No products to display.'); return; }
    root.querySelector('.ctl__headAside').hidden = !cards.length;
    root.dataset.ctlReady = '1';

    var money    = makeMoney(root.dataset.currency);
    var totalEl  = root.querySelector('[data-ctl-total]');
    var compEl   = root.querySelector('[data-ctl-compare]');
    var addBtn   = root.querySelector('[data-ctl-add]');
    var addLabel = root.querySelector('[data-ctl-add-label]');
    var baseLabel = addLabel.dataset.labelTemplate || addLabel.textContent.trim();
    var prevBtn  = root.querySelector('[data-ctl-prev]');
    var nextBtn  = root.querySelector('[data-ctl-next]');

    function setSelected(card, on) {
      if (card.classList.contains('is-selected') === on) return;
      card.classList.toggle('is-selected', on);
      var t = card.querySelector('[data-ctl-toggle]');
      if (t) t.setAttribute('aria-checked', String(on));
    }

    function recalc() {
      var now = 0, was = 0, n = 0;
      cards.forEach(function (c) {
        if (!c.classList.contains('is-selected')) return;
        var p = parseInt(c.dataset.price, 10) || 0;
        var q = parseInt(c.dataset.compare, 10) || 0;
        now += p; was += q > p ? q : p; n++;
      });
      totalEl.textContent = money(now);
      if (was > now) { compEl.textContent = money(was); compEl.hidden = false; }
      else { compEl.hidden = true; }

      addBtn.disabled = n === 0;
      addLabel.textContent = n === 0
        ? 'Select items to add'
        : baseLabel.replace('[count]', n).replace('[s]', n === 1 ? '' : 's');
    }

    /* ── 应用一个 option：价格 + 图片 + data 同步 ────── */
    function applyOption(card, opt) {
      if (!opt) return;
      card.dataset.variantId = opt.value;
      card.dataset.price     = opt.dataset.price;
      card.dataset.compare   = opt.dataset.compare || 0;

      var nowEl = card.querySelector('[data-ctl-now]');
      var wasEl = card.querySelector('[data-ctl-was]');
      var skuEl = card.querySelector('[data-ctl-sku]');
      if (nowEl) nowEl.textContent = opt.dataset.priceText;
      if (wasEl) {
        if (opt.dataset.compareText) { wasEl.textContent = opt.dataset.compareText; wasEl.hidden = false; }
        else { wasEl.hidden = true; }
      }
      if (skuEl) {
        skuEl.textContent = opt.dataset.sku || '';
        skuEl.parentElement.hidden = !opt.dataset.sku;
      }

      // 图片：预加载完成后再换，避免中间闪白
      var imgEl = card.querySelector('[data-ctl-img]');
      var next = opt.dataset.image;
      if (imgEl && next && imgEl.getAttribute('src') !== next) {
        imgEl.classList.add('is-swapping');
        var pre = new Image();
        pre.onload = function () {
          imgEl.src = next;
          imgEl.srcset = opt.dataset.srcset || '';
          if (opt.dataset.alt) imgEl.alt = opt.dataset.alt;
          imgEl.classList.remove('is-swapping');
        };
        pre.onerror = function () { imgEl.classList.remove('is-swapping'); };
        pre.src = next;
      }
    }

    cards.forEach(function (card) {
      var toggle = card.querySelector('[data-ctl-toggle]');
      var select = card.querySelector('[data-ctl-variant]');

      toggle.addEventListener('click', function () {
        var on = card.classList.toggle('is-selected');
        toggle.setAttribute('aria-checked', String(on));
        card.__ctlAutoOff = false;   // 用户手动定过，之后别再自动勾回来
        recalc();
      });

      if (select) {
        select.addEventListener('change', function () {
          applyOption(card, select.options[select.selectedIndex]);
          recalc();
        });
      }
    });

    function step() {
      var c = cards[0];
      if (!c) return track.clientWidth;
      var gap = parseFloat(getComputedStyle(track).columnGap || '20');
      var per = Math.max(1, Math.floor(track.clientWidth / (c.offsetWidth + gap)));
      return (c.offsetWidth + gap) * per;
    }
    prevBtn.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    nextBtn.addEventListener('click', function () { track.scrollBy({ left:  step(), behavior: 'smooth' }); });

    function syncNav() {
      var max = track.scrollWidth - track.clientWidth;
      // Scroll snapping can stop at the track's padded edge.
      var edge = (parseFloat(getComputedStyle(track).paddingLeft) || 0) + 1;
      prevBtn.disabled = track.scrollLeft <= edge;
      nextBtn.disabled = track.scrollLeft >= max - edge;
      root.querySelector('.ctl__foot').hidden = max <= 0;
    }
    track.addEventListener('scroll', syncNav, { passive: true });
    window.addEventListener('resize', syncNav);

    addBtn.addEventListener('click', function () {
      var items = cards
        .filter(function (c) { return c.classList.contains('is-selected'); })
        .map(function (c) { return { id: Number(c.dataset.variantId), quantity: 1 }; });
      if (!items.length) return;

      var payload = { items: items };
      var sections = cartSectionIds();
      if (sections.length) {
        payload.sections = sections.join(',');
        payload.sections_url = window.location.pathname;
      }

      addBtn.classList.add('is-busy');
      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(payload)
      })
        .then(function (r) { return r.json().then(function (d) { if (!r.ok) throw d; return d; }); })
        .then(function (data) {
          notifyTheme(items, data);
          syncCrisp();

          var after = root.dataset.afterAdd || 'cart_page';

          // 可靠路径：不碰 DOM，交给整页导航
          if (after === 'cart_page') { window.location.href = window.Shopify.routes.root + 'cart'; return; }
          if (after === 'reload')    { window.location.reload(); return; }
          if (after === 'stay')      return;

          // after === 'drawer'：尽力而为，主题依赖较重，见 schema 里的说明
          function fallback() {
            return softRefreshCart().then(function (ok) { return ok ? 'soft' : 'none'; });
          }
          var swapped = swapSections(data.sections);
          var ready;
          if (swapped.length) {
            reinitSections(swapped);
            ready = Promise.resolve('sections');
          } else {
            var t = themeCartRefresh();
            ready = t ? t.then(function (ok) { return ok ? 'theme' : fallback(); }) : fallback();
          }

          return Promise.resolve(ready).then(function (via) {
            if (isDesign()) console.log('[ctl] cart refresh', { via: via });
            setTimeout(function () {
              if (drawerIsOpen()) return;
              if (!openCartDrawer() && isDesign()) console.warn('[ctl] 找不到抽屉触发器');
            }, 250);
          });
        })
        .catch(function (e) {
          var msg = (e && e.description) || "Couldn't add — try again";
          if (typeof window.showWarning === 'function') {
            try { window.showWarning(msg, window.warningTime); } catch (err) {}
          }
          addLabel.textContent = msg;
          setTimeout(recalc, 2500);
        })
        .finally(function () { addBtn.classList.remove('is-busy'); });
    });

    /* ── 按当前商品的选项预选变体 ──────────────────────
       匹配不到就取消勾选：卡片照常显示，用户仍可手动勾回来，
       只是不再默认算进总价和加购。 */
    function syncToContext(names, values) {
      var ctx = {};
      (names || []).forEach(function (n, i) {
        if (values && values[i]) ctx[norm(n)] = norm(values[i]);
      });
      if (!Object.keys(ctx).length) return;

      cards.forEach(function (card) {
        var select = card.querySelector('[data-ctl-variant]');
        // 单变体商品没有选项可比（通用配件），勾选状态保持原样
        if (!select) return;

        var match = bestOption(select, ctx);
        if (!match) {
          // 打上标记：只有我们自动取消的，之后配上了才自动勾回来；
          // 用户手动取消的不碰。
          if (card.classList.contains('is-selected')) {
            setSelected(card, false);
            card.__ctlAutoOff = true;
          }
          return;
        }

        if (match.value !== select.value) {
          select.value = match.value;
          applyOption(card, match);
        }
        if (card.__ctlAutoOff) {
          setSelected(card, true);
          card.__ctlAutoOff = false;
        }
      });
      recalc();
    }

    // 暴露给 PDP 变体切换时调用
    root.__ctlSync = syncToContext;
    syncToContext(
      (root.dataset.ctxNames || '').split('|'),
      (root.dataset.ctxValues || '').split('|')
    );

    recalc();
    syncNav();
  }

  /* ── 异步拉取 section HTML ───────────────────────── */
  var isDesign = function () { return !!(window.Shopify && window.Shopify.designMode); };

  function bail(root, msg) {
    if (isDesign()) {
      // Theme Editor 里保留 section，把原因显示出来，方便排查
      root.querySelector('[data-ctl-track]').innerHTML =
        '<p style="padding:24px;color:#6B7280;font-size:14px;">' + msg + '</p>';
      root.querySelector('.ctl__foot').hidden = true;
      console.warn('[ctl]', msg, root.dataset.url);
    } else {
      root.remove();
    }
  }

  // 与解析期预取用同一个约定：永远 resolve 成 {html} 或 {err}
  function fetchTrack(url, priority) {
    return fetch(url, { priority: priority || 'auto' })
      .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.text(); })
      .then(function (html) { return { html: html }; })
      .catch(function (err) { return { err: err }; });
  }

  function consume(root, job, allowFallback) {
    job.then(function (res) {
      if (res.err) { bail(root, 'Recommendations request failed: ' + res.err.message); return; }

      var doc = document.createElement('div');
      doc.innerHTML = res.html;
      var incoming = doc.querySelector('[data-ctl-track]');
      var count = incoming ? incoming.querySelectorAll('.ctl-card:not(.ctl-card--skeleton)').length : 0;

      if (!count) {
        var fb = allowFallback && root.dataset.fallbackUrl;
        if (fb) { consume(root, fetchTrack(fb, root.dataset.requestPriority || 'auto'), false); return; }
        bail(root, 'No recommendations returned for this product. Check the Search & Discovery setup, or that the products are in stock.');
        return;
      }

      root.querySelector('[data-ctl-track]').innerHTML = incoming.innerHTML;
      if (root.dataset.ctlKey) {
        try { sessionStorage.setItem(root.dataset.ctlKey, incoming.innerHTML); } catch (e) {}
      }
      prependSelfCard(root);
      init(root);               // innerHTML 注入的 <script> 不会执行，必须手动 init
    });
  }

  function load(root, url, allowFallback) {
    consume(root, fetchTrack(url, root.dataset.requestPriority || 'auto'), allowFallback);
  }

  /* 直出的卡片 href 是干净的商品链接，少了 API 版本带的 pr_* 参数，
     Shopify 的推荐点击/转化报表会统计不到。滚到附近时补一次低优先级请求，
     只把 href 换成带参数的版本 —— 不动 DOM 结构，失败就保持原样。 */
  function patchTracking(root) {
    fetchTrack(root.dataset.url, 'low').then(function (res) {
      if (res.err) return;
      var doc = document.createElement('div');
      doc.innerHTML = res.html;

      var tracked = {};
      doc.querySelectorAll('[data-ctl-card] a[href*="pr_rec_pid"]').forEach(function (a) {
        var href = a.getAttribute('href');
        try { tracked[new URL(href, location.origin).pathname] = href; } catch (e) {}
      });

      root.querySelectorAll('[data-ctl-card] .ctl-card__name a, [data-ctl-card] .ctl-card__image-link').forEach(function (a) {
        try {
          var href = tracked[new URL(a.getAttribute('href'), location.origin).pathname];
          if (href) a.setAttribute('href', href);
        } catch (e) {}
      });
    });
  }

  function whenNear(root, fn) {
    if (isDesign() || typeof IntersectionObserver !== 'function') { fn(); return; }
    var io = new IntersectionObserver(function (entries, obs) {
      if (!entries[0].isIntersecting) return;
      obs.disconnect();
      fn();
    }, { rootMargin: '0px 0px 600px 0px' });
    io.observe(root);
  }

  function boot() {
    document.querySelectorAll('.ctl[data-ctl-root]').forEach(function (root) {
      if (root.dataset.ctlBooted === '1') return;
      root.dataset.ctlBooted = '1';

      // 卡片已经在 DOM 里：服务端直出，或解析期从 sessionStorage 同步塞进来的
      if (root.querySelector('.ctl-card:not(.ctl-card--skeleton)')) {
        init(root);
        if (root.dataset.ctlPr === '1') whenNear(root, function () { patchTracking(root); });
        return;
      }

      // 解析期已经把请求发出去了，这里只等结果
      var key = root.dataset.ctlKey;
      var pre = key && window.__ctlPre ? window.__ctlPre[key] : null;
      if (pre) { delete window.__ctlPre[key]; consume(root, pre, true); return; }

      // 兜底：预取脚本没跑到（编辑器 / 老缓存页）
      if (isDesign()) { load(root, root.dataset.url, true); return; }
      whenNear(root, function () { load(root, root.dataset.url, true); });
    });
  }

  /* ── PDP 主商品切换变体时同步 ────────────────────────
     不赌事件名，改为盯"变体 ID"——PDP 上唯一必然会变的东西，它不变加购就是错的。

     线上实测（Ella + Variant Swatch King），点一次颜色实际发生的是：
       history.replaceState → ?variant=<新ID>          ← 路 2 命中
       change 事件 ← 加购表单的 input[name="id"]        ← 路 3 命中
       vsk:product:variant:changed {variantId:"..."}    ← 路 1 命中
     而 variant:change / variant:changed / on:variant:selected / productVariantChange
     这几个通用事件名一个都不派发。之前那版赌事件名的实现就是死在这里，别再改回去。

     三路汇到 applyVariantId()，按 ID 去重，同一次切换只处理一次。
     ID 不在映射表里、或没有卡片打够分，都保持原样不动。
     排查：URL 带 ?ctldebug（或在 Theme Editor 里打开），控制台会打出走的是哪条路。
  ─────────────────────────────────────────────────── */
  var DEBUG;
  function debug() {
    if (DEBUG === undefined) DEBUG = isDesign() || /[?&]ctldebug\b/.test(window.location.search);
    if (DEBUG) console.log.apply(console, ['[ctl]'].concat(Array.prototype.slice.call(arguments)));
  }

  function eachRoot(fn) {
    document.querySelectorAll('.ctl[data-ctl-root]').forEach(fn);
  }

  function variantMap(root) {
    if (!root.__ctlMap) {
      var el = root.querySelector('[data-ctl-variant-map]');
      try { root.__ctlMap = el ? JSON.parse(el.textContent) : {}; }
      catch (e) { root.__ctlMap = {}; }
    }
    return root.__ctlMap;
  }

  /* 先写回 dataset 再同步：section 是懒加载的，用户完全可能在滚到它之前就切了色。
     init() 的初始上下文正是从 dataset 读的，这样那次切换不会被丢掉。 */
  function pushContext(root, values) {
    if (!values || !values.length) return;
    root.dataset.ctxValues = values.join('|');
    if (typeof root.__ctlSync === 'function') {
      root.__ctlSync((root.dataset.ctxNames || '').split('|'), values);
    }
  }

  function variantFromUrl() {
    var m = /[?&]variant=(\d+)/.exec(window.location.search);
    return m ? m[1] : '';
  }

  var lastVariantId = variantFromUrl();

  function applyVariantId(id, via) {
    id = String(id || '').trim();
    if (!id || id === lastVariantId) return;
    lastVariantId = id;
    eachRoot(function (root) {
      var opts = variantMap(root)[id];
      debug('variant', id, 'via', via, '→', opts || '不在映射表里，卡片保持原样');
      if (opts) pushContext(root, opts);
    });
  }

  // 路 1：主题自定义事件
  function onPdpVariant(e) {
    var v = e && e.detail && (e.detail.variant || e.detail);
    if (!v) return;
    var id = v.id || v.variantId;                 // Swatch King 给的键名是 variantId
    if (id) { applyVariantId(id, e.type); return; }
    var opts = v.options || v.option_values;      // 有的主题只给选项值不给 id
    if (!opts || !opts.length) return;
    lastVariantId = '';
    debug('options', opts, 'via', e.type);
    eachRoot(function (root) { pushContext(root, opts); });
  }

  // 路 2：URL
  function watchUrl() {
    ['pushState', 'replaceState'].forEach(function (name) {
      var orig = history[name];
      if (typeof orig !== 'function') return;
      history[name] = function () {
        var r = orig.apply(this, arguments);
        try { applyVariantId(variantFromUrl(), 'url:' + name); } catch (err) {}
        return r;
      };
    });
    window.addEventListener('popstate', function () {
      applyVariantId(variantFromUrl(), 'url:popstate');
    });
  }

  // 路 3：加购表单里的变体域
  var ID_SEL = 'input[name="id"],select[name="id"]';
  function fromVariantField(el) {
    if (!el || !el.value) return;
    var form = el.form || (el.closest && el.closest('form'));
    var action = form && form.getAttribute('action');
    if (action && !/\/cart\/add/.test(action)) return;   // 别撞上页面上无关的 name="id"
    applyVariantId(el.value, 'field');
  }

  /* Ella 是 jQuery 主题：$(el).val(id).trigger('change') 走 jQuery 自己的事件系统，
     原生 addEventListener 收不到。所以两边都要挂委托监听。 */
  var jqBound = false;
  function bindJq() {
    if (jqBound || !window.jQuery) return;
    jqBound = true;
    window.jQuery(document).on('change', ID_SEL, function () { fromVariantField(this); });
  }

  ['vsk:product:variant:changed',                 // 实测存在（Variant Swatch King）
   'variant:change', 'variant:changed', 'on:variant:selected', 'productVariantChange']
    .forEach(function (n) { document.addEventListener(n, onPdpVariant); });
  document.addEventListener('change', function (e) {
    if (e.target && e.target.matches && e.target.matches(ID_SEL)) fromVariantField(e.target);
  }, true);
  watchUrl();
  bindJq();
  window.addEventListener('load', bindJq);   // jQuery 可能比本脚本晚加载

  document.addEventListener('DOMContentLoaded', boot);
  // Theme editor 里重新渲染 section 后重新绑定
  document.addEventListener('shopify:section:load', boot);
  if (document.readyState !== 'loading') boot();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq-accordion"] && !Shopify.designMode) return;
  try {
    
(function () {
  var REDUCED = window.matchMedia && window.matchMedia('(prefers-reduced-motion:reduce)').matches;

  function panelOf(item) { return item.querySelector('.faq-item__a'); }

  function expand(item) {
    var panel = panelOf(item);
    if (!panel) return;
    item.open = true;
    if (REDUCED) { panel.style.height = ''; return; }
    var target = panel.scrollHeight;
    panel.style.height = '0px';
    // 强制一次回流，否则浏览器会把 0 → target 合并掉，动画不发生
    void panel.offsetHeight;
    panel.style.height = target + 'px';
    once(panel, function () { panel.style.height = ''; });
  }

  function collapse(item) {
    var panel = panelOf(item);
    if (!panel) return;
    if (REDUCED) { item.open = false; panel.style.height = ''; return; }
    panel.style.height = panel.scrollHeight + 'px';
    void panel.offsetHeight;
    panel.style.height = '0px';
    once(panel, function () { item.open = false; panel.style.height = ''; });
  }

  // height 过渡结束后清理；用超时兜底，避免 0→0 时 transitionend 永远不来
  function once(panel, done) {
    var fired = false;
    function finish() {
      if (fired) return;
      fired = true;
      panel.removeEventListener('transitionend', onEnd);
      clearTimeout(timer);
      done();
    }
    function onEnd(e) { if (e.target === panel && e.propertyName === 'height') finish(); }
    panel.addEventListener('transitionend', onEnd);
    var timer = setTimeout(finish, 400);
  }

  function init(root) {
    if (root.dataset.faqReady === '1') return;
    root.dataset.faqReady = '1';

    var single = root.dataset.single === '1';
    var items = Array.prototype.slice.call(root.querySelectorAll('.faq-item'));
    var limit = Number(root.dataset.faqPreviewLimit || 0);
    var more = root.querySelector('[data-faq-more]');
    if (limit && more && items.length > limit) {
      items.forEach(function (item, index) { item.hidden = index >= limit; });
      more.hidden = false;
      more.addEventListener('click', function () {
        var expanded = more.getAttribute('aria-expanded') !== 'true';
        // Move focus before hiding a question that may contain the keyboard focus.
        if (!expanded && items.slice(limit).some(function (item) { return item.contains(document.activeElement); })) more.focus();
        items.forEach(function (item, index) { item.hidden = !expanded && index >= limit; });
        more.setAttribute('aria-expanded', String(expanded));
        more.textContent = expanded ? 'Show fewer questions' : 'Show more questions';
      });
    }


    items.forEach(function (item) {
      var summary = item.querySelector('.faq-item__q');
      if (!summary) return;
      summary.addEventListener('click', function (e) {
        e.preventDefault();
        if (item.open) { collapse(item); return; }
        if (single) {
          items.forEach(function (other) { if (other !== item && other.open) collapse(other); });
        }
        expand(item);
      });
    });
  }

  function bootAll(scope) {
    (scope || document).querySelectorAll('[data-faq-root]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { bootAll(); });
  } else {
    bootAll();
  }

  document.addEventListener('shopify:section:load', function (e) { bootAll(e.target); });

  // theme editor 里点中某条 block，把对应问答展开
  document.addEventListener('shopify:block:select', function (e) {
    var item = e.target.closest ? e.target.closest('.faq-item') : null;
    if (item && !item.open) expand(item);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-mobile"]) return;
  try {
    
    class StickyHeaderMobile extends HTMLElement {
        constructor() {
            super();
        }
  
        connectedCallback() {
            this.header = document.querySelector('.section-header-mobile');
            this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
            this.headerBounds = {};
    
            if (this.headerIsAlwaysSticky) {
            this.header.classList.add('shopify-section-header-sticky');
            };
    
            this.currentScrollTop = 0;
            this.preventReveal = false;
            this.predictiveSearch = this.querySelector('predictive-search');
    
            this.onScrollHandler = this.onScroll.bind(this);
            this.hideHeaderOnScrollUp = () => this.preventReveal = true;
    
            this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
            window.addEventListener('scroll', this.onScrollHandler, false);
    
            this.createObserver();
        }
  
        disconnectedCallback() {
            this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
            window.removeEventListener('scroll', this.onScrollHandler);
        }
  
        createObserver() {
            let observer = new IntersectionObserver((entries, observer) => {
                this.headerBounds = entries[0].intersectionRect;
                observer.disconnect();
            });
    
            observer.observe(this.header);
        }
  
        onScroll() {
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    
            if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
    
            if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
                this.header.classList.add('scrolled-past-header');
                if (this.preventHide) return;
                requestAnimationFrame(this.hide.bind(this));
            } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
                this.header.classList.add('scrolled-past-header');
                if (!this.preventReveal) {
                    requestAnimationFrame(this.reveal.bind(this));
                } else {
                    window.clearTimeout(this.isScrolling);
        
                    this.isScrolling = setTimeout(() => {
                    this.preventReveal = false;
                    }, 66);
        
                    requestAnimationFrame(this.hide.bind(this));
                }
            } else if (scrollTop <= this.headerBounds.top) {
                this.header.classList.remove('scrolled-past-header');
                requestAnimationFrame(this.reset.bind(this));
            }
    
            this.currentScrollTop = scrollTop;
        }
  
        hide() {
            if (this.headerIsAlwaysSticky) return;
            this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
            this.header.style.top = '';
        }
  
        reveal() {
            const headerMultiSite = document.querySelector('.section-header-nav-multi-site');
            if (this.headerIsAlwaysSticky) return;
            this.header.classList.add('shopify-section-header-sticky', 'animate');
            this.header.classList.remove('shopify-section-header-hidden');
            if (headerMultiSite) {
                const height = headerMultiSite.offsetHeight;
                this.header.style.top = `${height}px`;
            }
        }
  
        reset() {
            if (this.headerIsAlwaysSticky) return;
            this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
            this.header.style.top = '';
        }
    }
  
    customElements.define('sticky-header-mobile', StickyHeaderMobile);

    document.querySelector('[data-mobile-menu]').addEventListener('click', () => {
        document.body.classList.toggle('menu_open');
    })

    function setCookie(cname, cvalue, exdays) {
        const d = new Date();
        d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
        const expires = "expires=" + d.toUTCString();
        document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    };

    function renderLogoMobile() {
        if ($("[data-menu-tab]").length > 0) {

            $(document).on("click", "[data-menu-tab] li", (event) => {
                var active = $(event.currentTarget).data("load-page"),
                    href = $(event.currentTarget).attr("href");

                $.cookie("page-url", active, {
                    expires: 1,
                    path: "/",
                });
            });

            var canonical = $("[canonical-shop-url]").attr("canonical-shop-url"),
            pageUrl = $.cookie("page-url"),
            menuTabItem,
            logoTabItem,
            menuItem;

            if (
                window.location.pathname.indexOf("/pages/") !== -1 &&
                window.page_active &&
                window.page_active != pageUrl
            ) {
                setCookie("page-url", window.page_active, 1);
                pageUrl = window.page_active;
            }
            
            if (pageUrl != null) {
                menuTabItem = $(`[data-load-page="${pageUrl}"]`);
                logoTabItem = $(`[data-load-logo-page="${pageUrl}"]`);
                menuItem = $(`[data-load-menu-page="${pageUrl}"]`);
            } else {
                menuTabItem = $("[data-load-page].is-active");
                logoTabItem = $("[data-load-logo-page].first");
                menuItem = $("[data-load-menu-page].is-active");
            }

            var menuTab = menuTabItem.closest("[data-menu-tab]");

            menuTab
                .find("[data-load-page]")
                .not(menuTabItem)
                .removeClass("is-active");
                logoTabItem.siblings().removeClass("is-active");
                menuItem.siblings().removeClass("is-active");
            if (pageUrl != "") {
                logoTabItem.addClass("is-active");
                menuTabItem.addClass("is-active");
                menuItem.addClass("is-active");
            } else {
                $("[data-load-page]:nth-child(1)").addClass("is-active");
                $("[data-load-logo-page]:nth-child(1)").addClass("is-active");
                $("[data-load-menu-page]:nth-child(1)").addClass("is-active");
            }

            const header = menuTabItem.closest(".header");

            
            if (header && window.innerWidth < 1025) {
                if (
                    window.location.pathname.indexOf("/pages/") !== -1 &&
                    window.page_active &&
                    window.page_active != pageUrl
                ) {
                    setCookie("page-url", window.page_active, 1);
                    pageUrl = window.page_active;
                }

                const logoMobile = $(".header-mobile .header__heading-link");
                const logDesktop = header.find(".header__heading-link.is-active");

                if (logDesktop.data("logo-mobile") == undefined) {
                    logoMobile.find("img").addClass("logo-show");
                    return;
                } else {
                    logoMobile.html(
                    `<img src="${logDesktop.data(
                        "logo-mobile"
                    )}" alt="${logDesktop.data(
                        "logo-mobile-alt"
                    )}" style="max-width: ${logoMobile.data(
                        "logo-width"
                    )}px; height: auto"/>`
                    );

                    logoMobile.find("img").addClass("logo-show");
                    if (pageUrl != "" && pageUrl != null)
                    logoMobile.attr("href", pageUrl);
                }
            }
        }
    }

    renderLogoMobile();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-nav-multi-site"] && !Shopify.designMode) return;
  try {
    
var sticky = document.getElementsByTagName('sticky-header')[0].querySelector('.header-nav-multi-site');
if (sticky != undefined || sticky != null) {
    class StickyHeader extends HTMLElement {
        constructor() {
          super();
        }
        connectedCallback() {
          this.header = document.querySelector('.section-header-navigation');
          this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type');
          this.headerBounds = {};
          this.setHeaderHeight();
          window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
          if (this.headerIsAlwaysSticky) {
            this.header.classList.add('shopify-section-header-sticky');
          };
          this.currentScrollTop = 0;
          this.preventReveal = false;
          this.predictiveSearch = this.querySelector('predictive-search');
          this.onScrollHandler = this.onScroll.bind(this);
          this.hideHeaderOnScrollUp = () => this.preventReveal = true;
          this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.addEventListener('scroll', this.onScrollHandler, false);
          this.createObserver();
        }

        setHeaderHeight() {
          document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
        }

        disconnectedCallback() {
          this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.removeEventListener('scroll', this.onScrollHandler);
        }

        createObserver() {
          let observer = new IntersectionObserver((entries, observer) => {
            this.headerBounds = entries[0].intersectionRect;
            observer.disconnect();
          });
          observer.observe(this.header);
        }

        onScroll() {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
          if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            if (this.preventHide) return;
            this.header.classList.add('scrolled-past-header');
            requestAnimationFrame(this.hide.bind(this));
          } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            this.header.classList.add('scrolled-past-header');
            if (!this.preventReveal) {
              requestAnimationFrame(this.reveal.bind(this));
            } else {
              window.clearTimeout(this.isScrolling);
              this.isScrolling = setTimeout(() => {
                this.preventReveal = false;
              }, 66);
              requestAnimationFrame(this.hide.bind(this));
            }
          } else if (scrollTop <= this.headerBounds.top) {
            this.header.classList.remove('scrolled-past-header');
            requestAnimationFrame(this.reset.bind(this));
          }
          this.currentScrollTop = scrollTop;
        }

        hide() {
            if (this.headerIsAlwaysSticky != null) {
                if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky');
                    return
                } else {
                    this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
                    this.header.classList.remove('shopify-section-header-show');
                }
            }
          this.closeMenuDisclosure();
        }

        reveal() {
            if (this.headerIsAlwaysSticky != null) {
              if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                  this.header.classList.add('shopify-section-header-sticky', 'shopify-section-header-show', 'animate');
                  this.header.classList.remove('shopify-section-header-hidden');
              }
            }
        }

        reset() {
            if (this.headerIsAlwaysSticky != null) {
              if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                  this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-show', 'shopify-section-header-sticky', 'animate');
              }
            }
        }

        closeMenuDisclosure() {
          this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
          this.disclosures.forEach(disclosure => disclosure.close());
        }
    }
    document.addEventListener('DOMContentLoaded', () => {customElements.define('sticky-header', StickyHeader)});
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-navigation-basic"] && !Shopify.designMode) return;
  try {
    
var sticky = document.getElementsByTagName('sticky-header')[0].querySelector('.header-nav-basic');
if (sticky != undefined || sticky != null) {
    class StickyHeader extends HTMLElement {
        constructor() {
          super();
        }

        connectedCallback() {
          this.header = document.querySelector('.section-header-navigation');
          this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type');

          this.headerBounds = {};

          this.setHeaderHeight();

          window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

          if (this.headerIsAlwaysSticky) {
            this.header.classList.add('shopify-section-header-sticky');
          };

          this.currentScrollTop = 0;
          this.preventReveal = false;
          this.predictiveSearch = this.querySelector('predictive-search');
          this.onScrollHandler = this.onScroll.bind(this);
          this.hideHeaderOnScrollUp = () => this.preventReveal = true;

          this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.addEventListener('scroll', this.onScrollHandler, false);

          this.createObserver();
        }

        setHeaderHeight() {
          document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
        }

        disconnectedCallback() {
          this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.removeEventListener('scroll', this.onScrollHandler);
        }

        createObserver() {
          let observer = new IntersectionObserver((entries, observer) => {
            this.headerBounds = entries[0].intersectionRect;
            observer.disconnect();
          });

          observer.observe(this.header);
        }

        onScroll() {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
          if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            if (this.preventHide) return;
            this.header.classList.add('scrolled-past-header');
            requestAnimationFrame(this.hide.bind(this));
          } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            this.header.classList.add('scrolled-past-header');

            if (!this.preventReveal) {
              requestAnimationFrame(this.reveal.bind(this));
            } else {
              window.clearTimeout(this.isScrolling);

              this.isScrolling = setTimeout(() => {
                this.preventReveal = false;
              }, 66);

              requestAnimationFrame(this.hide.bind(this));
            }
          } else if (scrollTop <= this.headerBounds.top) {
            this.header.classList.remove('scrolled-past-header');
            requestAnimationFrame(this.reset.bind(this));
          }

          this.currentScrollTop = scrollTop;
        }

        hide() {
            if (this.headerIsAlwaysSticky != null) {
                if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky');
                    return
                } else {
                    this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
                    this.header.classList.remove('shopify-section-header-show');
                }
            }
          this.closeMenuDisclosure();
        }

        reveal() {
            if (this.headerIsAlwaysSticky != null) {
              if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                  this.header.classList.add('shopify-section-header-sticky', 'shopify-section-header-show', 'animate');
                  this.header.classList.remove('shopify-section-header-hidden');
              }
            }
        }

        reset() {
            if (this.headerIsAlwaysSticky != null) {
              if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                  this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-show', 'shopify-section-header-sticky', 'animate');
              }
            }
        }

        closeMenuDisclosure() {
          this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
          this.disclosures.forEach(disclosure => disclosure.close());
        }
    }
    customElements.define('sticky-header', StickyHeader);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-navigation-compact"] && !Shopify.designMode) return;
  try {
    
var sticky = document.getElementsByTagName('sticky-header')[0].querySelector('.header-nav-compact');
if (sticky != undefined || sticky != null) {
    class StickyHeader extends HTMLElement {
        constructor() {
          super();
        }

        connectedCallback() {
          this.header = document.querySelector('.section-header-navigation');
          this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type');

          this.headerBounds = {};

          this.setHeaderHeight();

          window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

          if (this.headerIsAlwaysSticky) {
            this.header.classList.add('shopify-section-header-sticky');
          };

          this.currentScrollTop = 0;
          this.preventReveal = false;
          this.predictiveSearch = this.querySelector('predictive-search');
          this.onScrollHandler = this.onScroll.bind(this);
          this.hideHeaderOnScrollUp = () => this.preventReveal = true;

          this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.addEventListener('scroll', this.onScrollHandler, false);

          this.createObserver();
        }

        setHeaderHeight() {
          document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
        }

        disconnectedCallback() {
          this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.removeEventListener('scroll', this.onScrollHandler);
        }

        createObserver() {
          let observer = new IntersectionObserver((entries, observer) => {
            this.headerBounds = entries[0].intersectionRect;
            observer.disconnect();
          });

          observer.observe(this.header);
        }

        onScroll() {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
          if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            if (this.preventHide) return;
            this.header.classList.add('scrolled-past-header');
            requestAnimationFrame(this.hide.bind(this));
          } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            this.header.classList.add('scrolled-past-header');

            if (!this.preventReveal) {
              requestAnimationFrame(this.reveal.bind(this));
            } else {
              window.clearTimeout(this.isScrolling);

              this.isScrolling = setTimeout(() => {
                this.preventReveal = false;
              }, 66);

              requestAnimationFrame(this.hide.bind(this));
            }
          } else if (scrollTop <= this.headerBounds.top) {
            this.header.classList.remove('scrolled-past-header');
            requestAnimationFrame(this.reset.bind(this));
          }

          this.currentScrollTop = scrollTop;
        }

        hide() {
            if (this.headerIsAlwaysSticky != null) {
                if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky');
                    return
                } else {
                    this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
                    this.header.classList.remove('shopify-section-header-show');
                }
            }
          this.closeMenuDisclosure();
        }

        reveal() {
            if (this.headerIsAlwaysSticky != null) {
              if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                  this.header.classList.add('shopify-section-header-sticky', 'shopify-section-header-show', 'animate');
                  this.header.classList.remove('shopify-section-header-hidden');
              }
            }
        }

        reset() {
            if (this.headerIsAlwaysSticky != null) {
              if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                  this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-show', 'shopify-section-header-sticky', 'animate');
              }
            }
        }

        closeMenuDisclosure() {
          this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
          this.disclosures.forEach(disclosure => disclosure.close());
        }
    }
    customElements.define('sticky-header', StickyHeader);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-navigation-full-elements"] && !Shopify.designMode) return;
  try {
    
var sticky = document.getElementsByTagName('sticky-header')[0].querySelector('.header-nav-full-elements');
if (sticky != undefined || sticky != null) {

    class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header-navigation');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type');

      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');
      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        this.header.classList.add('scrolled-past-header');
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');

        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
        if (this.headerIsAlwaysSticky != null) {
            if (this.headerIsAlwaysSticky === 'always') {
                this.header.classList.add('shopify-section-header-sticky');
                return
            } else {
                this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
                this.header.classList.remove('shopify-section-header-show');
            }
        }
      this.closeMenuDisclosure();
    }

    reveal() {
        if (this.headerIsAlwaysSticky != null) {
          if (this.headerIsAlwaysSticky === 'always') {
                this.header.classList.add('shopify-section-header-sticky', 'animate');
                return
            } else {
              this.header.classList.add('shopify-section-header-sticky', 'shopify-section-header-show', 'animate');
              this.header.classList.remove('shopify-section-header-hidden');
          }
        }
    }

    reset() {
        if (this.headerIsAlwaysSticky != null) {
          if (this.headerIsAlwaysSticky === 'always') {
                this.header.classList.add('shopify-section-header-sticky', 'animate');
                return
            } else {
              this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-show', 'shopify-section-header-sticky', 'animate');
          }
        }
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
      this.disclosures.forEach(disclosure => disclosure.close());
    }
  }

  customElements.define('sticky-header', StickyHeader);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-navigation-hamburger"] && !Shopify.designMode) return;
  try {
    
var sticky = document.getElementsByTagName('sticky-header')[0].querySelector('.header-nav-hamburger');
if (sticky != undefined || sticky != null) {
    class StickyHeader extends HTMLElement {
        constructor() {
          super();
        }

        connectedCallback() {
          this.header = document.querySelector('.section-header-navigation');
          this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type');
          this.headerBounds = {};
          this.setHeaderHeight();
          window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
          if (this.headerIsAlwaysSticky) {
            this.header.classList.add('shopify-section-header-sticky');
          };
          this.currentScrollTop = 0;
          this.preventReveal = false;
          this.predictiveSearch = this.querySelector('predictive-search');
          this.onScrollHandler = this.onScroll.bind(this);
          this.hideHeaderOnScrollUp = () => this.preventReveal = true;
          this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.addEventListener('load', this.checkLoadPosition.bind(this));
          window.addEventListener('scroll', this.onScrollHandler, false);
          this.createObserver();
        }
        setHeaderHeight() {
          document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
        }
        disconnectedCallback() {
          this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.removeEventListener('load', this.checkLoadPosition);
          window.removeEventListener('scroll', this.onScrollHandler);
        }
        createObserver() {
          let observer = new IntersectionObserver((entries, observer) => {
            this.headerBounds = entries[0].intersectionRect;
            observer.disconnect();
          });
          observer.observe(this.header);
        }
        checkLoadPosition() {
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
            const headerGr = document.querySelectorAll(".shopify-section-group-header-group");

            if(headerGr[0].classList.contains('shopify-section-header-sticky')) {
                if(scrollTop > headerGr[0].offsetHeight && !this.header.classList.contains('scrolled-past-header')) {
                    this.header.classList.add('shopify-section-header-hidden');
                }
            } else {
                headerGr.forEach(item => {
                    if(item.classList.contains('shopify-section-header-sticky') ) {
                        const itemPrev = item.previousElementSibling;
                        const itemPrevHeight = itemPrev.offsetHeight;
                        const itemPrevTop = itemPrev.offsetTop;

                        if(scrollTop > itemPrevTop + itemPrevHeight && !this.header.classList.contains('scrolled-past-header')) {
                            this.header.classList.add('shopify-section-header-hidden');
                        }
                    }
                });
            }
        }
        onScroll() {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
          if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            if (this.preventHide) return;
            this.header.classList.add('scrolled-past-header');
            requestAnimationFrame(this.hide.bind(this));
          } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            this.header.classList.add('scrolled-past-header');
            if (!this.preventReveal) {
              requestAnimationFrame(this.reveal.bind(this));
            } else {
              window.clearTimeout(this.isScrolling);

              this.isScrolling = setTimeout(() => {
                this.preventReveal = false;
              }, 66);
              requestAnimationFrame(this.hide.bind(this));
            }
          } else if (scrollTop <= this.headerBounds.top) {
            this.header.classList.remove('scrolled-past-header');
            requestAnimationFrame(this.reset.bind(this));
          }
          this.currentScrollTop = scrollTop;
        }
        hide() {
            if (this.headerIsAlwaysSticky != null) {
                if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky');
                    return
                } else {
                    this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
                    this.header.classList.remove('shopify-section-header-show');
                    document.querySelector('body').classList.add("section-header-is-hidden")
                }
            }
          this.closeMenuDisclosure();
        }
        reveal() {
            if (this.headerIsAlwaysSticky != null) {
              if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                  this.header.classList.add('shopify-section-header-sticky', 'shopify-section-header-show', 'animate');
                  this.header.classList.remove('shopify-section-header-hidden');
                  document.querySelector('body').classList.remove("section-header-is-hidden")
              }
            }
        }
        reset() {
            if (this.headerIsAlwaysSticky != null) {
              if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                  this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-show', 'shopify-section-header-sticky', 'animate');
                  document.querySelector('body').classList.remove("section-header-is-hidden")
              }
            }
        }
        closeMenuDisclosure() {
          this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
          this.disclosures.forEach(disclosure => disclosure.close());
        }
    }
    customElements.define('sticky-header', StickyHeader);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-navigation-left-aligned"] && !Shopify.designMode) return;
  try {
    
var sticky = document.getElementsByTagName('sticky-header')[0].querySelector('.header-nav-left-aligned');
if (sticky != undefined || sticky != null) {
    class StickyHeader extends HTMLElement {
        constructor() {
          super();
        }

        connectedCallback() {
          this.header = document.querySelector('.section-header-navigation');
          this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type');

          this.headerBounds = {};

          this.setHeaderHeight();

          window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

          if (this.headerIsAlwaysSticky) {
            this.header.classList.add('shopify-section-header-sticky');
          };

          this.currentScrollTop = 0;
          this.preventReveal = false;
          this.predictiveSearch = this.querySelector('predictive-search');
          this.onScrollHandler = this.onScroll.bind(this);
          this.hideHeaderOnScrollUp = () => this.preventReveal = true;

          this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.addEventListener('scroll', this.onScrollHandler, false);

          this.createObserver();
        }

        setHeaderHeight() {
          document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
        }

        disconnectedCallback() {
          this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.removeEventListener('scroll', this.onScrollHandler);
        }

        createObserver() {
          let observer = new IntersectionObserver((entries, observer) => {
            this.headerBounds = entries[0].intersectionRect;
            observer.disconnect();
          });

          observer.observe(this.header);
        }

        onScroll() {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
          if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            if (this.preventHide) return;
            this.header.classList.add('scrolled-past-header');
            requestAnimationFrame(this.hide.bind(this));
          } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            this.header.classList.add('scrolled-past-header');

            if (!this.preventReveal) {
              requestAnimationFrame(this.reveal.bind(this));
            } else {
              window.clearTimeout(this.isScrolling);

              this.isScrolling = setTimeout(() => {
                this.preventReveal = false;
              }, 66);

              requestAnimationFrame(this.hide.bind(this));
            }
          } else if (scrollTop <= this.headerBounds.top) {
            this.header.classList.remove('scrolled-past-header');
            requestAnimationFrame(this.reset.bind(this));
          }

          this.currentScrollTop = scrollTop;
        }

        hide() {
            if (this.headerIsAlwaysSticky != null) {
                if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky');
                    return
                } else {
                    this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
                    this.header.classList.remove('shopify-section-header-show');
                }
            }
          this.closeMenuDisclosure();
        }

        reveal() {
            if (this.headerIsAlwaysSticky != null) {
              if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                  this.header.classList.add('shopify-section-header-sticky', 'shopify-section-header-show', 'animate');
                  this.header.classList.remove('shopify-section-header-hidden');
              }
            }
        }

        reset() {
            if (this.headerIsAlwaysSticky != null) {
              if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                  this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-show', 'shopify-section-header-sticky', 'animate');
              }
            }
        }

        closeMenuDisclosure() {
          this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
          this.disclosures.forEach(disclosure => disclosure.close());
        }
    }

    customElements.define('sticky-header', StickyHeader);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-navigation-plain"] && !Shopify.designMode) return;
  try {
    
var sticky = document.getElementsByTagName('sticky-header')[0].querySelector('.header-nav-plain');

if (sticky != undefined || sticky != null) {
    class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header-navigation');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type');

      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');
      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        this.header.classList.add('scrolled-past-header');
        document.body.classList.add('scrolled-header');
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        document.body.classList.add('scrolled-header');

        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        document.body.classList.remove('scrolled-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
        if (this.headerIsAlwaysSticky != null) {
            if (this.headerIsAlwaysSticky === 'always') {
                this.header.classList.add('shopify-section-header-sticky');
                return
            } else {
                this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
                this.header.classList.remove('shopify-section-header-show');
            }
        }
      this.closeMenuDisclosure();
    }

    reveal() {
        if (this.headerIsAlwaysSticky != null) {
          if (this.headerIsAlwaysSticky === 'always') {
                this.header.classList.add('shopify-section-header-sticky', 'animate');
                return
            } else {
              this.header.classList.add('shopify-section-header-sticky', 'shopify-section-header-show', 'animate');
              this.header.classList.remove('shopify-section-header-hidden');
          }
        }
    }

    reset() {
        if (this.headerIsAlwaysSticky != null) {
          if (this.headerIsAlwaysSticky === 'always') {
                this.header.classList.add('shopify-section-header-sticky', 'animate');
                return
            } else {
              this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-show', 'shopify-section-header-sticky', 'animate');
          }
        }
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
      this.disclosures.forEach(disclosure => disclosure.close());
    }
  }

  customElements.define('sticky-header', StickyHeader);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-navigation-utility"] && !Shopify.designMode) return;
  try {
    
var sticky = document.getElementsByTagName('sticky-header')[0].querySelector('.header-nav-utility');
if (sticky != undefined || sticky != null) {
    class StickyHeader extends HTMLElement {
        constructor() {
          super();
        }

        connectedCallback() {
          this.header = document.querySelector('.section-header-navigation');
          this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type');

          this.headerBounds = {};

          this.setHeaderHeight();

          window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

          if (this.headerIsAlwaysSticky) {
            this.header.classList.add('shopify-section-header-sticky');
          };

          this.currentScrollTop = 0;
          this.preventReveal = false;
          this.predictiveSearch = this.querySelector('predictive-search');
          this.onScrollHandler = this.onScroll.bind(this);
          this.hideHeaderOnScrollUp = () => this.preventReveal = true;

          this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.addEventListener('scroll', this.onScrollHandler, false);

          this.createObserver();
        }

        setHeaderHeight() {
          document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
        }

        disconnectedCallback() {
          this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.removeEventListener('scroll', this.onScrollHandler);
        }

        createObserver() {
          let observer = new IntersectionObserver((entries, observer) => {
            this.headerBounds = entries[0].intersectionRect;
            observer.disconnect();
          });

          observer.observe(this.header);
        }

        onScroll() {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
          if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            if (this.preventHide) return;
            this.header.classList.add('scrolled-past-header');
            requestAnimationFrame(this.hide.bind(this));
          } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            this.header.classList.add('scrolled-past-header');

            if (!this.preventReveal) {
              requestAnimationFrame(this.reveal.bind(this));
            } else {
              window.clearTimeout(this.isScrolling);

              this.isScrolling = setTimeout(() => {
                this.preventReveal = false;
              }, 66);

              requestAnimationFrame(this.hide.bind(this));
            }
          } else if (scrollTop <= this.headerBounds.top) {
            this.header.classList.remove('scrolled-past-header');
            requestAnimationFrame(this.reset.bind(this));
          }

          this.currentScrollTop = scrollTop;
        }

        hide() {
            if (this.headerIsAlwaysSticky != null) {
                if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky');
                    return
                } else {
                    this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
                    this.header.classList.remove('shopify-section-header-show');
                }
            }
          this.closeMenuDisclosure();
        }

        reveal() {
            if (this.headerIsAlwaysSticky != null) {
              if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                  this.header.classList.add('shopify-section-header-sticky', 'shopify-section-header-show', 'animate');
                  this.header.classList.remove('shopify-section-header-hidden');
              }
            }
        }

        reset() {
            if (this.headerIsAlwaysSticky != null) {
              if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                  this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-show', 'shopify-section-header-sticky', 'animate');
              }
            }
        }

        closeMenuDisclosure() {
          this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
          this.disclosures.forEach(disclosure => disclosure.close());
        }
    }

    customElements.define('sticky-header', StickyHeader);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-navigation-vertical-menu"] && !Shopify.designMode) return;
  try {
    
var sticky = document.getElementsByTagName('sticky-header')[0].querySelector('.header-nav-vertical-menu');
if (sticky != undefined || sticky != null) {
    class StickyHeader extends HTMLElement {
        constructor() {
          super();
        }

        connectedCallback() {
          this.header = document.querySelector('.section-header-navigation');
          this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type');

          this.headerBounds = {};

          this.setHeaderHeight();

          window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

          if (this.headerIsAlwaysSticky) {
            this.header.classList.add('shopify-section-header-sticky');
          };

          this.currentScrollTop = 0;
          this.preventReveal = false;
          this.predictiveSearch = this.querySelector('predictive-search');
          this.onScrollHandler = this.onScroll.bind(this);
          this.hideHeaderOnScrollUp = () => this.preventReveal = true;

          this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.addEventListener('scroll', this.onScrollHandler, false);

          this.createObserver();
        }

        setHeaderHeight() {
          document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
        }

        disconnectedCallback() {
          this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.removeEventListener('scroll', this.onScrollHandler);
        }

        createObserver() {
          let observer = new IntersectionObserver((entries, observer) => {
            this.headerBounds = entries[0].intersectionRect;
            observer.disconnect();
          });

          observer.observe(this.header);
        }

        onScroll() {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
          if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            if (this.preventHide) return;
            this.header.classList.add('scrolled-past-header');
            requestAnimationFrame(this.hide.bind(this));
          } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            this.header.classList.add('scrolled-past-header');

            if (!this.preventReveal) {
              requestAnimationFrame(this.reveal.bind(this));
            } else {
              window.clearTimeout(this.isScrolling);

              this.isScrolling = setTimeout(() => {
                this.preventReveal = false;
              }, 66);

              requestAnimationFrame(this.hide.bind(this));
            }
          } else if (scrollTop <= this.headerBounds.top) {
            this.header.classList.remove('scrolled-past-header');
            requestAnimationFrame(this.reset.bind(this));
          }

          this.currentScrollTop = scrollTop;
        }

        hide() {
            if (this.headerIsAlwaysSticky != null) {
                if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky');
                    return
                } else {
                    this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
                    this.header.classList.remove('shopify-section-header-show');
                }
                if(!$('.vertical-menu').hasClass('vertical-menu__style_3')){
                    $('.vertical-menu').addClass('vertical-menu__hide');
                }
            }
          this.closeMenuDisclosure();
        }

        reveal() {
            if (this.headerIsAlwaysSticky != null) {
              if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                  this.header.classList.add('shopify-section-header-sticky', 'shopify-section-header-show', 'animate');
                  this.header.classList.remove('shopify-section-header-hidden');
              }
            }
        }

        reset() {
            if (this.headerIsAlwaysSticky != null) {
              if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                  this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-show', 'shopify-section-header-sticky', 'animate');
              }
              if(!$('.vertical-menu').hasClass('vertical-menu__style_3')){
                  if (document.body.classList.contains('template-index')) {
                      if ($('.vertical-menu').hasClass('vertical-menu__hide')) {
                          $('.vertical-menu').removeClass('vertical-menu__hide');
                      }
                  }
              }
            }
        }

        closeMenuDisclosure() {
          this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
          this.disclosures.forEach(disclosure => disclosure.close());
        }
    }

  customElements.define('sticky-header', StickyHeader);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mbs-campaign-benefits"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('pointerdown', (event) => {
  document.querySelectorAll('.mbs-campaign-benefits [data-campaign-info][open]').forEach((info) => {
    if (!info.contains(event.target)) info.open = false;
  });
});
document.addEventListener('keydown', (event) => {
  if (event.key !== 'Escape') return;
  document.querySelectorAll('.mbs-campaign-benefits [data-campaign-info][open]').forEach((info) => {
    info.open = false;
    if (info.contains(event.target)) info.querySelector('summary').focus();
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mbs-sale-event"] && !Shopify.designMode) return;
  try {
    
(() => {
  function updateSaleEvents() {
    const now = Math.floor(Date.now() / 1000);
    document.querySelectorAll('[data-sale-event]').forEach((event) => {
      if (event.dataset.editor === 'true' || event.dataset.scheduled !== 'true') return;
      const start = Number(event.dataset.start);
      const end = Number(event.dataset.end);
      event.hidden = (start > 0 && now < start) || (end > 0 && now >= end);
    });
  }
  updateSaleEvents();
  document.addEventListener('shopify:section:load', updateSaleEvents);
  window.setInterval(updateSaleEvents, 30000);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["package-options"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  function init(root) {
    if (root.dataset.pkgReady === '1') return;
    root.dataset.pkgReady = '1';

    if (root.dataset.sourceMode === 'linked_variant_metafield' || root.dataset.sourceMode === 'auto') {
      var refreshController;
      root.__pkgRefresh = function (variantId) {
        variantId = String(variantId || '');
        if (!variantId || variantId === root.dataset.sourceVariantId) return;
        if (refreshController) refreshController.abort();
        refreshController = new AbortController();
        root.setAttribute('aria-busy', 'true');

        var url = new URL(root.dataset.productUrl || window.location.pathname, window.location.origin);
        url.searchParams.set('variant', variantId);
        url.searchParams.set('section_id', root.dataset.sectionId);

        fetch(url.toString(), { headers: { 'Accept': 'text/html' }, signal: refreshController.signal })
          .then(function (response) {
            if (!response.ok) throw new Error('Could not refresh package options.');
            return response.text();
          })
          .then(function (html) {
            var page = new DOMParser().parseFromString(html, 'text/html');
            var replacement = page.querySelector('[data-pkg-root]');
            if (!replacement) throw new Error('Package options response was empty.');
            root.replaceWith(replacement);
            init(replacement);
          })
          .catch(function (error) {
            if (error.name === 'AbortError') return;
            root.removeAttribute('aria-busy');
            var refreshStatus = root.querySelector('[data-pkg-status]');
            if (refreshStatus) refreshStatus.textContent = error.message || 'Could not refresh package options.';
          });
      };
    }

    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-pkg-card]'));
    var details = Array.prototype.slice.call(root.querySelectorAll('[data-pkg-detail]'));

    root.querySelectorAll('[data-pkg-more]').forEach(function (button) {
      button.addEventListener('click', function () {
        var panel = button.closest('[data-pkg-detail]');
        var extras = panel.querySelectorAll('[data-pkg-extra]');
        var expanded = button.getAttribute('aria-expanded') === 'true';
        extras.forEach(function (row) { row.hidden = expanded; });
        button.setAttribute('aria-expanded', String(!expanded));
        button.textContent = expanded ? '+ ' + extras.length + ' more items' : 'Show fewer items';
      });
    });

    if (!cards.length) return;

    var track = root.querySelector('[data-pkg-track]');
    var detailsWrap = root.querySelector('[data-pkg-details]');
    var status = root.querySelector('[data-pkg-status]');
    var busy = false;

    function selectCard(card, shouldScroll) {
      var position = card.dataset.position;
      cards.forEach(function (candidate) {
        var on = candidate === card;
        candidate.classList.toggle('is-selected', on);
        candidate.querySelectorAll('[data-pkg-select]').forEach(function (button) {
          if (button.hasAttribute('aria-pressed')) button.setAttribute('aria-pressed', String(on));
        });
        var add = candidate.querySelector('[data-pkg-add]');
        if (add) add.classList.toggle('pkg-button--primary', on);
      });
      details.forEach(function (detail) { detail.hidden = detail.dataset.pkgDetail !== position; });
      if (detailsWrap) detailsWrap.hidden = false;
      if (shouldScroll) card.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
    }

    cards.forEach(function (card) {
      card.querySelectorAll('[data-pkg-select]').forEach(function (button) {
        button.addEventListener('click', function () { selectCard(card, true); });
      });
    });

    function move(direction) {
      if (!track || !cards.length) return;
      var gap = parseFloat(window.getComputedStyle(track).columnGap || window.getComputedStyle(track).gap) || 0;
      track.scrollBy({ left: direction * (cards[0].getBoundingClientRect().width + gap), behavior: 'smooth' });
    }
    var prev = root.querySelector('[data-pkg-prev]');
    var next = root.querySelector('[data-pkg-next]');
    if (prev) prev.addEventListener('click', function () { move(-1); });
    if (next) next.addEventListener('click', function () { move(1); });

    function setBusy(on, variantId) {
      busy = on;
      root.querySelectorAll('[data-pkg-add]').forEach(function (button) {
        button.disabled = on || button.dataset.variantId === '' || button.closest('[data-pkg-card]') && button.closest('[data-pkg-card]').dataset.available !== 'true';
        if (button.dataset.variantId === variantId) button.textContent = on ? 'Adding…' : root.dataset.buttonLabel || 'Add Package to Cart';
      });
    }

    root.querySelectorAll('[data-pkg-add]').forEach(function (button) {
      button.addEventListener('click', function () {
        if (busy) return;
        var variantId = button.dataset.variantId;
        var rootUrl = root.dataset.rootUrl || '/';
        status.textContent = '';
        root.dataset.buttonLabel = button.textContent.trim();
        setBusy(true, variantId);

        fetch(rootUrl + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] })
        })
          .then(function (response) {
            return response.json().then(function (data) {
              if (!response.ok) throw data;
              return data;
            });
          })
          .then(function (data) {
            status.textContent = 'Package added to cart.';
            document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: data }));
            document.dispatchEvent(new CustomEvent('package:added', { bubbles: true, detail: { variantId: Number(variantId), cart: data } }));
            if (typeof window.postCart === 'function') { try { window.postCart(); } catch (error) {} }

            if (root.dataset.afterAdd === 'cart_page') window.location.href = rootUrl + 'cart';
            else if (root.dataset.afterAdd === 'reload') window.location.reload();
          })
          .catch(function (error) {
            status.textContent = error && (error.description || error.message) ? (error.description || error.message) : 'Could not add this package. Please try again.';
          })
          .finally(function () { setBusy(false, variantId); });
      });
    });

    var initial = cards.find(function (card) { return card.classList.contains('is-selected'); });
    if (initial) selectCard(initial, false);
    else {
      details.forEach(function (detail) { detail.hidden = true; });
      if (detailsWrap) detailsWrap.hidden = true;
    }
  }

  function boot(scope) {
    (scope || document).querySelectorAll('[data-pkg-root]').forEach(init);
  }

  function activeProductVariantId() {
    var input = document.querySelector('product-form form[action*="/cart/add"] [name="id"], form[action*="/cart/add"] [name="id"]');
    if (input && input.value) return input.value;
    return new URL(window.location.href).searchParams.get('variant') || '';
  }

  function refreshLinkedPackages(variantId) {
    if (!variantId) return;
    document.querySelectorAll('[data-pkg-root][data-source-mode="linked_variant_metafield"], [data-pkg-root][data-source-mode="auto"]').forEach(function (root) {
      if (typeof root.__pkgRefresh === 'function') root.__pkgRefresh(variantId);
    });
  }

  function installVariantWatcher() {
    if (window.__packageOptionsVariantWatcher) return;
    window.__packageOptionsVariantWatcher = true;
    var lastVariantId = activeProductVariantId();

    function check(detail) {
      var eventVariant = detail && detail.variant;
      var id = eventVariant && eventVariant.id || detail && (detail.variantId || detail.id) || activeProductVariantId();
      id = String(id || '');
      if (!id || id === lastVariantId) return;
      lastVariantId = id;
      refreshLinkedPackages(id);
    }

    ['variant:change', 'variant:changed', 'product:variant-change', 'product:variant-changed'].forEach(function (eventName) {
      document.addEventListener(eventName, function (event) { check(event.detail); });
    });
    document.addEventListener('change', function () { window.setTimeout(check, 0); }, true);
    window.setInterval(check, 500);
  }

  document.addEventListener('DOMContentLoaded', function () { boot(document); installVariantWatcher(); });
  document.addEventListener('shopify:section:load', function (event) { boot(event.target); });
  if (document.readyState !== 'loading') { boot(document); installVariantWatcher(); }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-documents"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  var registry = window.__mbsProductDocuments = window.__mbsProductDocuments || { roots: [] };

  function loadViewerScript(url) {
    if (window.FlyfishFileViewerWebFull) return Promise.resolve(window.FlyfishFileViewerWebFull);
    if (registry.viewerPromise) return registry.viewerPromise;

    registry.viewerPromise = new Promise(function (resolve, reject) {
      if (!url) {
        reject(new Error('No document viewer URL configured.'));
        return;
      }

      var existing = document.querySelector('script[data-mbs-docs-viewer]');
      var script = existing || document.createElement('script');

      function ready() {
        if (window.FlyfishFileViewerWebFull) resolve(window.FlyfishFileViewerWebFull);
        else reject(new Error('Document viewer did not initialise.'));
      }

      script.addEventListener('load', ready, { once: true });
      script.addEventListener('error', function () { reject(new Error('Document viewer failed to load.')); }, { once: true });

      if (!existing) {
        script.src = url;
        script.async = true;
        script.dataset.mbsDocsViewer = '1';
        document.head.appendChild(script);
      }
    });

    return registry.viewerPromise;
  }

  function fileNameFor(url, label, fileType) {
    var fileName = '';
    try {
      fileName = decodeURIComponent(new URL(url, window.location.href).pathname.split('/').pop() || '');
    } catch (error) {}
    if (fileName && fileName.indexOf('.') !== -1) return fileName;
    var safeLabel = String(label || 'document').trim().replace(/[^a-z0-9._-]+/gi, '-').replace(/^-+|-+$/g, '') || 'document';
    return safeLabel + (fileType ? '.' + fileType : '');
  }

  function activeVariantId() {
    var urlVariant = new URL(window.location.href).searchParams.get('variant');
    if (urlVariant) return urlVariant;
    var input = document.querySelector('product-form form[action*="/cart/add"] [name="id"], form[action*="/cart/add"] [name="id"]');
    return input && input.value ? String(input.value) : '';
  }

  function init(root) {
    if (!root || root.dataset.mbsDocsReady === '1') return;
    root.dataset.mbsDocsReady = '1';

    var rows = Array.prototype.slice.call(root.querySelectorAll('[data-doc-row]'));
    var filters = Array.prototype.slice.call(root.querySelectorAll('[data-doc-filter]'));
    var empty = root.querySelector('[data-doc-empty]');
    var status = root.querySelector('[data-doc-status]');
    var showAllButton = root.querySelector('[data-doc-show-all]');
    var showAllText = root.querySelector('[data-doc-show-all-text]');
    var scopeNote = root.querySelector('[data-doc-scope-note]');
    var currentVariant = root.querySelector('[data-doc-current-variant]');
    var previewDialog = root.querySelector('[data-doc-preview-dialog]');
    var previewBody = root.querySelector('[data-doc-preview-body]');
    var previewTitle = root.querySelector('[data-doc-preview-title]');
    var previewOriginal = root.querySelector('[data-doc-preview-original]');
    var previewClose = root.querySelector('[data-doc-preview-close]');
    var previewController = null;
    var previewRequestId = 0;
    var lastPreviewTrigger = null;
    var state = {
      category: 'all',
      variantId: activeVariantId() || root.dataset.selectedVariantId || '',
      variantTitle: root.dataset.selectedVariantTitle || 'Selected variant',
      allVariants: false
    };

    function titleForVariant(id) {
      if (!id) return root.dataset.selectedVariantTitle || 'Selected variant';
      var matchingRow = rows.find(function (row) { return row.dataset.variantId === id && row.dataset.variantTitle; });
      if (matchingRow) return matchingRow.dataset.variantTitle;
      if (id === root.dataset.selectedVariantId) return root.dataset.selectedVariantTitle || 'Selected variant';
      return 'Selected variant';
    }

    function render(announce) {
      var visible = 0;
      var selectedScopeCount = 0;
      var compact = root.dataset.docPresentation === 'compact';
      var scopedRows = rows.filter(function (row) {
        return state.allVariants || !row.dataset.variantId || row.dataset.variantId === state.variantId;
      });
      var filtersWrap = root.querySelector('.mbs-docs__filters-wrap');
      if (compact && filtersWrap) {
        filters.forEach(function (button) {
          var category = button.dataset.docFilter;
          button.hidden = category !== 'all' && !scopedRows.some(function (row) { return row.dataset.category === category; });
        });
        filtersWrap.hidden = scopedRows.length <= 1;
        if (filtersWrap.hidden || !scopedRows.some(function (row) { return row.dataset.category === state.category; })) {
          state.category = 'all';
        }
        filters.forEach(function (button) {
          var active = button.dataset.docFilter === state.category;
          button.classList.toggle('is-active', active);
          button.setAttribute('aria-pressed', String(active));
        });
      }

      rows.forEach(function (row) {
        var categoryMatches = state.category === 'all' || row.dataset.category === state.category;
        var productWide = !row.dataset.variantId;
        var variantMatches = productWide || row.dataset.variantId === state.variantId;
        if (!productWide && row.dataset.variantId === state.variantId && !row.dataset.variantTitle) {
          row.dataset.variantTitle = state.variantTitle;
          var scope = row.querySelector('[data-doc-scope]');
          if (scope) scope.textContent = root.dataset.variantPrefix + state.variantTitle;
        }
        if (variantMatches) selectedScopeCount += 1;
        var show = categoryMatches && (state.allVariants || variantMatches);
        row.hidden = !show;
        if (show) visible += 1;
      });

      if (empty) empty.hidden = visible !== 0;
      if (currentVariant) currentVariant.textContent = state.variantTitle;
      if (scopeNote) scopeNote.hidden = state.allVariants || (compact && !scopedRows.some(function (row) { return !!row.dataset.variantId; }));

      if (showAllButton) {
        var hasOtherVariantDocuments = rows.length > selectedScopeCount;
        showAllButton.hidden = !hasOtherVariantDocuments;
        showAllButton.setAttribute('aria-pressed', String(state.allVariants));
        if (showAllText) {
          showAllText.textContent = state.allVariants
            ? root.dataset.showSelectedLabel
            : root.dataset.showAllLabel + ' ' + rows.length + ' ' + root.dataset.showAllNoun;
        }
      }

      if (compact) {
        var footer = root.querySelector('.mbs-docs__footer');
        if (footer) footer.hidden = (!showAllButton || showAllButton.hidden) && (!scopeNote || scopeNote.hidden);
      }

      if (announce && status) {
        status.textContent = visible + ' ' + (visible === 1 ? root.dataset.fileSingular : root.dataset.filePlural) + ' shown.';
      }
    }

    filters.forEach(function (button) {
      button.addEventListener('click', function () {
        state.category = button.dataset.docFilter || 'all';
        filters.forEach(function (candidate) {
          var active = candidate === button;
          candidate.classList.toggle('is-active', active);
          candidate.setAttribute('aria-pressed', String(active));
        });
        render(true);
      });
    });

    if (showAllButton) {
      showAllButton.addEventListener('click', function () {
        state.allVariants = !state.allVariants;
        render(true);
      });
    }

    function clearPreview() {
      previewRequestId += 1;
      if (previewController && typeof previewController.destroy === 'function') previewController.destroy();
      previewController = null;
      if (previewBody) previewBody.replaceChildren();
    }

    function closePreview() {
      if (!previewDialog) return;
      if (previewDialog.open && typeof previewDialog.close === 'function') previewDialog.close();
      else previewDialog.removeAttribute('open');
    }

    function showPreviewMessage(message) {
      if (!previewBody) return;
      var text = document.createElement('p');
      text.className = 'mbs-docs__preview-message';
      text.textContent = message;
      previewBody.replaceChildren(text);
    }

    function openPreview(button) {
      if (!previewDialog || !previewBody) return;
      var url = button.dataset.previewUrl || '';
      var label = button.dataset.previewLabel || 'Document preview';
      var fileType = button.dataset.previewFileType || '';
      var fileName = fileNameFor(url, label, fileType);

      lastPreviewTrigger = button;
      clearPreview();
      var requestId = previewRequestId;
      showPreviewMessage(root.dataset.loadingPreviewLabel || 'Loading preview…');
      if (previewTitle) previewTitle.textContent = label;
      if (previewOriginal) previewOriginal.href = url;
      var modalDownload = previewDialog.querySelector('[data-doc-download]');
      if (modalDownload) {
        modalDownload.href = url;
        modalDownload.dataset.downloadLabel = label;
        modalDownload.dataset.downloadFileType = fileType;
      }

      if (typeof previewDialog.showModal === 'function') previewDialog.showModal();
      else previewDialog.setAttribute('open', '');

      if (button.dataset.previewKind === 'image') {
        var image = document.createElement('img');
        image.className = 'mbs-docs__preview-image';
        image.alt = label;
        image.addEventListener('load', function () {
          if (requestId === previewRequestId && previewDialog.open) previewBody.replaceChildren(image);
        }, { once: true });
        image.addEventListener('error', function () {
          if (requestId === previewRequestId) showPreviewMessage('This image could not be previewed. You can still open or download the original file.');
        }, { once: true });
        image.src = url;
        return;
      }

      loadViewerScript(root.dataset.viewerScriptUrl).then(function (viewerApi) {
        if (!previewDialog.open || requestId !== previewRequestId) return;
        var viewer = document.createElement('div');
        viewer.className = 'mbs-docs__preview-viewer';
        previewBody.replaceChildren(viewer);
        previewController = viewerApi.mountViewer(viewer, {
          url: url,
          filename: fileName,
          options: {
            theme: 'light',
            toolbar: { position: 'bottom-right' }
          }
        });
      }).catch(function () {
        if (requestId === previewRequestId) showPreviewMessage('This file could not be previewed here. You can still open or download the original file.');
      });
    }

    root.querySelectorAll('[data-doc-preview]').forEach(function (button) {
      button.addEventListener('click', function () { openPreview(button); });
    });

    if (previewClose) previewClose.addEventListener('click', closePreview);
    if (previewDialog) {
      previewDialog.addEventListener('click', function (event) {
        if (event.target === previewDialog) closePreview();
      });
      previewDialog.addEventListener('close', function () {
        clearPreview();
        if (lastPreviewTrigger) lastPreviewTrigger.focus();
      });
    }

    root.addEventListener('click', function (event) {
      var link = event.target.closest('[data-doc-download]');
      if (!link || !root.contains(link) || !window.fetch || !window.URL || !window.URL.createObjectURL) return;

      event.preventDefault();
      var url = link.href;
      var label = link.dataset.downloadLabel || 'document';
      var fileType = link.dataset.downloadFileType || '';
      var fileName = fileNameFor(url, label, fileType);
      link.setAttribute('aria-busy', 'true');
      if (status) status.textContent = 'Preparing ' + fileName + ' for download.';

      fetch(url, { credentials: 'same-origin' }).then(function (response) {
        if (!response.ok) throw new Error('Download request failed.');
        return response.blob();
      }).then(function (blob) {
        var objectUrl = URL.createObjectURL(blob);
        var download = document.createElement('a');
        download.href = objectUrl;
        download.download = fileName;
        document.body.appendChild(download);
        download.click();
        download.remove();
        window.setTimeout(function () { URL.revokeObjectURL(objectUrl); }, 1000);
        if (status) status.textContent = fileName + ' download started.';
      }).catch(function () {
        if (status) status.textContent = 'Direct download is unavailable. Opening the file in this tab.';
        window.location.assign(url);
      }).finally(function () {
        link.removeAttribute('aria-busy');
      });
    });

    root.__mbsDocsSetVariant = function (variantId) {
      variantId = String(variantId || '');
      if (!variantId || variantId === state.variantId) return;
      state.variantId = variantId;
      state.variantTitle = titleForVariant(variantId);
      state.allVariants = false;
      render(true);
    };

    registry.roots.push(root);
    render(false);
  }

  function boot(scope) {
    (scope || document).querySelectorAll('[data-mbs-docs]').forEach(init);
  }

  function notifyVariant(variantId) {
    variantId = String(variantId || activeVariantId() || '');
    if (!variantId) return;
    registry.roots = registry.roots.filter(function (root) { return document.documentElement.contains(root); });
    registry.roots.forEach(function (root) {
      if (typeof root.__mbsDocsSetVariant === 'function') root.__mbsDocsSetVariant(variantId);
    });
  }

  function installVariantWatcher() {
    if (registry.watching) return;
    registry.watching = true;
    var lastVariantId = activeVariantId();

    function check(detail) {
      var eventVariant = detail && detail.variant;
      var id = eventVariant && eventVariant.id || detail && (detail.variantId || detail.variant_id || detail.id) || activeVariantId();
      id = String(id || '');
      if (!id || id === lastVariantId) return;
      lastVariantId = id;
      notifyVariant(id);
    }

    ['vsk:product:variant:changed', 'variant:change', 'variant:changed', 'on:variant:selected', 'productVariantChange', 'product:variant-change', 'product:variant-changed'].forEach(function (eventName) {
      document.addEventListener(eventName, function (event) { check(event.detail); });
    });
    document.addEventListener('change', function () { window.setTimeout(function () { check(); }, 0); }, true);
    window.addEventListener('popstate', function () { check(); });

    ['pushState', 'replaceState'].forEach(function (name) {
      var original = history[name];
      if (!original || original.__mbsDocsWrapped) return;
      function wrapped() {
        var result = original.apply(this, arguments);
        window.setTimeout(function () { check(); }, 0);
        return result;
      }
      wrapped.__mbsDocsWrapped = true;
      history[name] = wrapped;
    });

    window.setInterval(function () { check(); }, 700);
  }

  document.addEventListener('DOMContentLoaded', function () { boot(document); installVariantWatcher(); });
  document.addEventListener('shopify:section:load', function (event) { boot(event.target); });
  if (document.readyState !== 'loading') { boot(document); installVariantWatcher(); }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rv-recently-viewed"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';

    var NAME = 'shopify_recently_viewed', MAX = 20;

    function isDesign() { return !!(window.Shopify && window.Shopify.designMode); }

    /* ── 存储：与 Ella / Shopify.Products 共用同一份 ──── */
    function raw() {
      if (isDesign()) { try { return localStorage.getItem(NAME) || ''; } catch (e) { return ''; } }
      var m = document.cookie.match(/(?:^|;\s*)shopify_recently_viewed=([^;]*)/);
      try { return m ? decodeURIComponent(m[1]) : ''; } catch (e) { return m ? m[1] : ''; }
    }
    function read() { return raw().split(/[\s+]+/).filter(Boolean); }
    function save(arr, days) {
      var val = arr.slice(0, MAX).join(' ');
      if (isDesign()) { try { localStorage.setItem(NAME, val); } catch (e) {} return; }
      var exp = new Date(Date.now() + (days || 30) * 86400000).toUTCString();
      document.cookie = NAME + '=' + encodeURIComponent(val)
                      + ';expires=' + exp + ';path=/;SameSite=Lax';
    }
    function drop(dead, days) {
      if (!dead.length) return;
      save(read().filter(function (h) { return dead.indexOf(h) === -1; }), days);
    }

    /* ── 金额格式化 ──────────────────────────────────────
       用 shop.money_format 注入的格式串，覆盖 Shopify 的全部占位符。
       多币种（Markets）时用 Shopify.currency.rate 换算。 */
    function group(cents, decimals, thousands, decimal) {
      if (isNaN(cents) || cents === null) return '0';
      var parts = (cents / 100).toFixed(decimals).split('.');
      var head = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      return parts[1] ? head + decimal + parts[1] : head;
    }
    function money(cents, format, strip) {
      var rate = (window.Shopify && window.Shopify.currency && parseFloat(window.Shopify.currency.rate)) || 1;
      cents = Math.round(cents * rate);

      var out = format.replace(/\{\{\s*(\w+)\s*\}\}/g, function (_, token) {
        switch (token) {
          case 'amount':                                  return group(cents, 2, ',', '.');
          case 'amount_no_decimals':                      return group(cents, 0, ',', '.');
          case 'amount_with_comma_separator':             return group(cents, 2, '.', ',');
          case 'amount_no_decimals_with_comma_separator': return group(cents, 0, '.', ',');
          case 'amount_with_apostrophe_separator':        return group(cents, 2, "'", '.');
          case 'amount_with_space_separator':             return group(cents, 2, ' ', ',');
          case 'amount_no_decimals_with_space_separator': return group(cents, 0, ' ', ',');
          default:                                        return group(cents, 2, ',', '.');
        }
      });
      if (strip) out = out.replace(/([.,])00(?!\d)/, '');   // 等价于 money_without_trailing_zeros
      return out;
    }

    function sized(url, w) {
      if (!url) return '';
      return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
    }
    function esc(s) {
      return String(s == null ? '' : s)
        .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;');
    }

    function cardHTML(p, cfg) {
      var mode = p.sales_mode;
      var restricted = mode === 'enquire' || mode === 'quote';
      var now = p.price_min != null ? p.price_min : p.price;
      var cmp = p.compare_at_price_min != null ? p.compare_at_price_min : p.compare_at_price;
      var img = p.featured_image;
      var variants = p.variants || [];
      var variant = variants.find(function (item) { return item.available; }) || variants[0];
      var sku = variant && variant.sku ? String(variant.sku).trim() : '';
      var url = window.Shopify.routes.root + 'products/' + p.handle;
      if (variant && variant.id) url += '?variant=' + encodeURIComponent(variant.id);

      return '<article class="rv-card" data-rv-handle="' + esc(p.handle) + '"'
           + ' bss-b2b-product-id="' + p.id + '">'
        + '<a class="rv-card__link" href="' + esc(url) + '">'
        +   '<div class="rv-card__media' + (cfg.fit === 'contain' ? ' rv-card__media--contain' : '') + '">'
        +     (img
                ? '<img src="' + esc(sized(img, 500)) + '"'
                  + ' srcset="' + esc(sized(img, 300)) + ' 300w, ' + esc(sized(img, 500)) + ' 500w, ' + esc(sized(img, 700)) + ' 700w"'
                  + ' sizes="(max-width: 560px) 180px, 220px"'
                  + ' alt="' + esc(p.title) + '" loading="lazy" decoding="async">'
                : '')
        +   '</div>'
        +   '<div class="rv-card__body">'
        +     '<h3 class="rv-card__name">' + esc(p.title) + '</h3>'
        +     (sku ? '<p class="rv-card__sku">' + ((p.variant_count || variants.length) > 1 ? 'Variant SKU: ' : 'SKU: ') + esc(sku) + '</p>' : '')
        +     '<p class="rv-card__price">'
        +       (mode === 'quote' ? '<span class="rv-card__now">' + esc(cfg.priceRequestLabel) + '</span>' : '')
        +       (mode !== 'quote' && p.price_varies ? '<span class="rv-card__from">' + esc(cfg.fromLabel) + '</span>' : '')
        +       (mode === 'quote' ? '' : '<span class="rv-card__now">' + money(now, cfg.format, cfg.strip) + '</span>')
        +       (mode !== 'quote' && cmp > now ? '<s class="rv-card__was">' + money(cmp, cfg.format, cfg.strip) + '</s>' : '')
        +     '</p>'
        +     (restricted || p.available ? '' : '<p class="rv-card__flag">' + esc(cfg.soldoutLabel) + '</p>')
        +   '</div>'
        + '</a>'
        + (restricted ? '<div class="rv-card__enquiry"><a class="button mbs-sales-cta" href="' + esc(url + '#product-enquiry') + '">' + esc(mode === 'quote' ? cfg.quoteLabel : cfg.enquireLabel) + '</a></div>' : '')
        + '</article>';
    }

    function fetchProduct(handle) {
      return fetch(window.Shopify.routes.root + 'products/' + encodeURIComponent(handle) + '?view=mbs-recently-viewed',
                   { headers: { 'Accept': 'text/html' } })
        .then(function (r) {
          if (r.status === 404) return { missing: true };
          if (!r.ok) throw new Error(r.status);
          return r.json();
        })
        .then(function (data) {
          if (data.missing) return data;
          if (!data.product || !['standard', 'enquire', 'quote'].includes(data.sales_mode)) return null;
          data.product.sales_mode = data.sales_mode;
          return data.product;
        })
        .catch(function () { return null; });
    }

    function initCarousel(root) {
      var track = root.querySelector('[data-rv-track]');
      var nav = root.querySelector('[data-rv-nav]');
      var prev = root.querySelector('[data-rv-prev]');
      var next = root.querySelector('[data-rv-next]');

      function step() {
        var card = track.querySelector('.rv-card');
        if (!card) return track.clientWidth;
        var gap = parseFloat(getComputedStyle(track).columnGap || '16');
        var per = Math.max(1, Math.floor(track.clientWidth / (card.offsetWidth + gap)));
        return (card.offsetWidth + gap) * per;
      }
      function sync() {
        var max = track.scrollWidth - track.clientWidth;
        prev.disabled = track.scrollLeft <= 1;
        next.disabled = track.scrollLeft >= max - 1;
        nav.hidden = max <= 0;          // 一屏放得下就不显示箭头
      }
      prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
      next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
      track.addEventListener('scroll', sync, { passive: true });
      window.addEventListener('resize', sync);
      sync();
    }

    function build(root) {
      if (root.dataset.rvReady === '1') return;
      root.dataset.rvReady = '1';

      var current = root.dataset.current || '';
      var days = parseInt(root.dataset.expiryDays, 10) || 30;

      // 记录已由上方的同步内联脚本完成，这里只负责读
      var list = read();
      if (root.dataset.excludeCurrent === '1' && current) {
        list = list.filter(function (h) { return h !== current; });
      }

      var limit = parseInt(root.dataset.limit, 10) || 6;
      var handles = list.slice(0, limit);

      if (!handles.length) {
        if (isDesign()) {
          root.querySelector('[data-rv-track]').innerHTML =
            '<p style="padding:24px;color:#6B7280;font-size:14px;">' +
            'No browsing history yet. Visit a few product pages, then come back.</p>';
          root.querySelector('[data-rv-nav]').hidden = true;
        } else {
          root.remove();
        }
        return;
      }

      var cfg = {
        format: root.dataset.moneyFormat || ('${' + '{amount}}'),
        strip: root.dataset.stripZeros === '1',
        fit: root.dataset.imageFit,
        fromLabel: root.dataset.fromLabel || 'from',
        soldoutLabel: root.dataset.soldoutLabel || 'Sold out',
        priceRequestLabel: root.dataset.priceRequestLabel,
        enquireLabel: root.dataset.enquireLabel,
        quoteLabel: root.dataset.quoteLabel
      };

      Promise.all(handles.map(fetchProduct)).then(function (results) {
        var dead = [], html = '';
        results.forEach(function (p, i) {
          if (p && p.handle) html += cardHTML(p, cfg);
          else if (p && p.missing) dead.push(handles[i]);          // 404 → 商品已下架，从 cookie 剪掉
        });
        drop(dead, days);

        if (!html) { root.remove(); return; }
        root.querySelector('[data-rv-track]').innerHTML = html;   // 骨架屏在此被整体替换
        initCarousel(root);
        // 给 B2B / 多币种类 app 一个重新扫描的机会
        document.dispatchEvent(new CustomEvent('rv:rendered', { bubbles: true, detail: { root: root } }));
      }).catch(function () { root.remove(); });
    }

    /* 骨架屏撑出了盒子，IntersectionObserver 才能正常工作。
       模块通常在页面下方，滚到附近才发请求，不占首屏带宽。 */
    function bootAll() {
      document.querySelectorAll('.rv[data-rv-root]').forEach(function (root) {
        if (root.dataset.rvBooted === '1') return;
        root.dataset.rvBooted = '1';

        var clear = root.querySelector('[data-rv-clear]');
        if (clear) {
          clear.addEventListener('click', function () {
            save([], -1);                                  // 过期时间设成过去 → 立即失效
            try { localStorage.removeItem(NAME); } catch (e) {}
            root.remove();
          });
        }

        if (isDesign()) { build(root); return; }
        new IntersectionObserver(function (entries, obs) {
          if (!entries[0].isIntersecting) return;
          obs.disconnect();
          build(root);
        }, { rootMargin: '0px 0px 400px 0px' }).observe(root);
      });
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bootAll);
    else bootAll();
    document.addEventListener('shopify:section:load', bootAll);
  })();
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ymal-bundle"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  function makeMoney(currency) {
    var nf = new Intl.NumberFormat(document.documentElement.lang || 'en-AU', {
      style: 'currency', currency: currency || 'AUD',
      minimumFractionDigits: 0, maximumFractionDigits: 2
    });
    return function (cents) { return nf.format(cents / 100).replace(/^[A-Z]{1,2}\$/, '$'); };
  }

  /* ── 选项值归一化与匹配 ─────────────────────────── */
  function norm(s) {
    return String(s || '').toLowerCase().trim()
      .replace(/[-_/]/g, ' ')
      .replace(/\s+/g, ' ')
      .replace(/\bmatt\b/g, 'matte')       // Matt Black / Matte Black
      .replace(/\bbrush\b/g, 'brushed')
      .replace(/\bs\/steel\b/g, 'stainless steel');
  }

  function loose(a, b) {
    if (a.length < 3 || b.length < 3) return false;
    return a.indexOf(b) > -1 || b.indexOf(a) > -1;
  }

  // 打分：同名选项精确匹配 3 分，同名模糊 1 分；名称对不上时跨名比对
  function bestOption(select, ctx) {
    var names = (select.dataset.optNames || '').split('|').map(norm);
    var best = null, bestScore = 0;

    Array.prototype.forEach.call(select.options, function (o) {
      if (o.disabled) return;
      var vals = (o.dataset.optValues || '').split('|').map(norm);
      var score = 0;

      names.forEach(function (n, i) {
        if (!ctx[n] || !vals[i]) return;
        if (ctx[n] === vals[i]) score += 3;
        else if (loose(ctx[n], vals[i])) score += 1;
      });

      if (score === 0) {
        Object.keys(ctx).forEach(function (k) {
          vals.forEach(function (val) {
            if (ctx[k] === val) score += 2;
            else if (loose(ctx[k], val)) score += 1;
          });
        });
      }

      if (score > bestScore) { bestScore = score; best = o; }
    });

    // 阈值 2：弱匹配不覆盖商家设定的默认变体
    return bestScore >= 2 ? best : null;
  }

  /* ── 购物车刷新 ─────────────────────────────────────
     1) cartSectionIds()  探测页面上与购物车相关的 section
     2) swapSections()    把服务端重渲染的 HTML 换进 DOM
     3) notifyTheme()     广播主题可能监听的事件
     4) openCartDrawer()  打开抽屉（这一步最依赖主题，见下方注释）
  ─────────────────────────────────────────────────── */
  var CART_RE = /cart|basket|minicart/i;

  function cartSectionIds() {
    var ids = [];
    document.querySelectorAll('[id^="shopify-section-"]').forEach(function (el) {
      var id = el.id.replace('shopify-section-', '');
      if (CART_RE.test(id) && ids.indexOf(id) === -1) ids.push(id);
    });
    return ids;
  }

  function swapSections(map) {
    var done = [];
    if (!map) return done;
    Object.keys(map).forEach(function (id) {
      var host = document.getElementById('shopify-section-' + id);
      if (!host || !map[id]) return;
      var doc = new DOMParser().parseFromString(map[id], 'text/html');
      var inner = doc.getElementById('shopify-section-' + id);
      host.innerHTML = inner ? inner.innerHTML : map[id];
      done.push(id);
    });
    return done;
  }

  /* innerHTML 替换会销毁主题绑在旧节点上的直接事件监听器（jQuery .on(el)）。
     广播 shopify:section:load 让主题重新初始化——OS2.0 主题普遍监听这个事件，
     Ella 的 jQuery 侧也一并 trigger 一次。 */
  function reinitSections(ids) {
    ids.forEach(function (id) {
      var host = document.getElementById('shopify-section-' + id);
      var detail = { sectionId: id, load: host };
      document.dispatchEvent(new CustomEvent('shopify:section:load', { bubbles: true, detail: detail }));
      if (host) host.dispatchEvent(new CustomEvent('shopify:section:load', { bubbles: true, detail: detail }));
      if (window.jQuery) window.jQuery(document).trigger('shopify:section:load', [detail]);
    });
  }

  // 抽屉不是 OS2.0 section 时的兜底：重新拉当前页，只换抽屉节点
  var DRAWER_SEL = 'cart-drawer,#CartDrawer,.cart-drawer,#mini-cart,.mini-cart,#sidebar-cart';
  var COUNT_SEL = '[data-cart-count],.cart-count,.cart-count-bubble,.header-cart__count,.site-header__cart-count';

  function softRefreshCart() {
    return fetch(window.location.href, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var done = false;
        var fresh = doc.querySelector(DRAWER_SEL), live = document.querySelector(DRAWER_SEL);
        if (fresh && live) { live.innerHTML = fresh.innerHTML; done = true; }
        var fc = doc.querySelector(COUNT_SEL), lc = document.querySelector(COUNT_SEL);
        if (fc && lc) { lc.innerHTML = fc.innerHTML; done = true; }
        return done;
      })
      .catch(function () { return false; });
  }

  /* Shopify.onCartUpdate 默认是遗留桩函数——弹 alert("There are now N items in the cart.")，
     本意是让主题覆盖它。Ella 并没有覆盖，所以直接调会弹原生对话框。
     这里检测函数体，只有在主题真的覆盖过之后才使用。

     另外两个 Ella 全局的真实用途，别搞错：
       getCartUpdate(line, quantity, cb)  改数量/删除，POST /cart/change.js，不是刷新
       postCart()                          Crisp 的购物车同步，与主题渲染无关 */
  function isLegacyStub(fn) {
    try {
      return /There are now|items in the cart/i.test(Function.prototype.toString.call(fn));
    } catch (e) { return true; }
  }

  function themeCartRefresh() {
    var fn = window.Shopify && window.Shopify.onCartUpdate;
    if (typeof fn !== 'function' || isLegacyStub(fn)) return null;
    return fetch(window.Shopify.routes.root + 'cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { fn(cart); return true; })
      .catch(function () { return false; });
  }

  // Crisp 的购物车同步，任何刷新路径之后都该调一次
  function syncCrisp() {
    if (typeof window.postCart === 'function') { try { window.postCart(); } catch (e) {} }
  }

  // 主题可能已经自己把抽屉打开了，避免我们再点一次把它关掉
  var OPEN_RE = /(^|\s)(is-open|is-active|active|open|drawer-open|js-drawer-open|cart-open|show)(\s|$)/;
  function drawerIsOpen() {
    var el = document.querySelector(DRAWER_SEL);
    if (el && OPEN_RE.test(el.className)) return true;
    return OPEN_RE.test(document.body.className) || OPEN_RE.test(document.documentElement.className);
  }

  function notifyTheme(items, data) {
    var detail = { items: items, cart: data };
    ['ymal:added', 'cart:refresh', 'cart:updated', 'cart:build', 'ajaxCart:afterCartLoad']
      .forEach(function (n) {
        document.dispatchEvent(new CustomEvent(n, { bubbles: true, detail: detail }));
      });
    // Ella 6.x 基于 jQuery，原生 CustomEvent 触发不到 jQuery 监听器
    if (window.jQuery) {
      ['cart:refresh', 'cart:updated', 'ajaxCart:afterCartLoad']
        .forEach(function (n) { window.jQuery(document).trigger(n, [data]); });
    }
  }

  function openCartDrawer() {
    // 先点主题的购物车触发器：委托绑定（$(document).on）在 DOM 替换后仍然有效，
    // 而抽屉节点上的直接绑定已经随 innerHTML 一起没了。
    var trigger = document.querySelector(
      '[data-cart-drawer-toggle],[data-action="open-cart"],.js-drawer-open-right,' +
      '.site-header__cart,.header-cart,.cart-icon-bubble,a[href$="/cart"][data-drawer]'
    );
    if (trigger) { trigger.click(); return true; }

    var el = document.querySelector(DRAWER_SEL);
    if (el && typeof el.open === 'function') { el.open(); return true; }
    return false;
  }

  /* ── 绑定一个已填充好的 root ─────────────────────── */
  function init(root) {
    if (root.dataset.ymalReady === '1') return;

    var track = root.querySelector('[data-ymal-track]');
    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-ymal-card]'));

    if (!track.querySelector('.ymal-card')) { bail(root, 'No products to display.'); return; }
    root.querySelector('.ymal__headAside').hidden = !cards.length;
    root.dataset.ymalReady = '1';

    var money    = makeMoney(root.dataset.currency);
    var totalEl  = root.querySelector('[data-ymal-total]');
    var compEl   = root.querySelector('[data-ymal-compare]');
    var addBtn   = root.querySelector('[data-ymal-add]');
    var addLabel = root.querySelector('[data-ymal-add-label]');
    var baseLabel = addLabel.dataset.labelTemplate || addLabel.textContent.trim();
    var prevBtn  = root.querySelector('[data-ymal-prev]');
    var nextBtn  = root.querySelector('[data-ymal-next]');

    function recalc() {
      var now = 0, was = 0, n = 0;
      cards.forEach(function (c) {
        if (!c.classList.contains('is-selected')) return;
        var p = parseInt(c.dataset.price, 10) || 0;
        var q = parseInt(c.dataset.compare, 10) || 0;
        now += p; was += q > p ? q : p; n++;
      });
      totalEl.textContent = money(now);
      if (was > now) { compEl.textContent = money(was); compEl.hidden = false; }
      else { compEl.hidden = true; }

      addBtn.disabled = n === 0;
      addLabel.textContent = n === 0
        ? 'Select items to add'
        : baseLabel.replace('[count]', n).replace('[s]', n === 1 ? '' : 's');
    }

    /* ── 应用一个 option：价格 + 图片 + data 同步 ────── */
    function applyOption(card, opt) {
      if (!opt) return;
      card.dataset.variantId = opt.value;
      card.dataset.price     = opt.dataset.price;
      card.dataset.compare   = opt.dataset.compare || 0;

      var nowEl = card.querySelector('[data-ymal-now]');
      var wasEl = card.querySelector('[data-ymal-was]');
      var skuEl = card.querySelector('[data-ymal-sku]');
      if (nowEl) nowEl.textContent = opt.dataset.priceText;
      if (wasEl) {
        if (opt.dataset.compareText) { wasEl.textContent = opt.dataset.compareText; wasEl.hidden = false; }
        else { wasEl.hidden = true; }
      }
      if (skuEl) {
        skuEl.textContent = opt.dataset.sku || '';
        skuEl.parentElement.hidden = !opt.dataset.sku;
      }

      // 图片：预加载完成后再换，避免中间闪白
      var imgEl = card.querySelector('[data-ymal-img]');
      var next = opt.dataset.image;
      if (imgEl && next && imgEl.getAttribute('src') !== next) {
        imgEl.classList.add('is-swapping');
        var pre = new Image();
        pre.onload = function () {
          imgEl.src = next;
          imgEl.srcset = opt.dataset.srcset || '';
          if (opt.dataset.alt) imgEl.alt = opt.dataset.alt;
          imgEl.classList.remove('is-swapping');
        };
        pre.onerror = function () { imgEl.classList.remove('is-swapping'); };
        pre.src = next;
      }
    }

    cards.forEach(function (card) {
      var toggle = card.querySelector('[data-ymal-toggle]');
      var select = card.querySelector('[data-ymal-variant]');

      toggle.addEventListener('click', function () {
        var on = card.classList.toggle('is-selected');
        toggle.setAttribute('aria-checked', String(on));
        recalc();
      });

      if (select) {
        select.addEventListener('change', function () {
          applyOption(card, select.options[select.selectedIndex]);
          recalc();
        });
      }
    });

    function step() {
      var c = cards[0];
      if (!c) return track.clientWidth;
      var gap = parseFloat(getComputedStyle(track).columnGap || '20');
      var per = Math.max(1, Math.floor(track.clientWidth / (c.offsetWidth + gap)));
      return (c.offsetWidth + gap) * per;
    }
    prevBtn.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    nextBtn.addEventListener('click', function () { track.scrollBy({ left:  step(), behavior: 'smooth' }); });

    function syncNav() {
      var max = track.scrollWidth - track.clientWidth;
      // Scroll snapping can stop at the track's padded edge.
      var edge = (parseFloat(getComputedStyle(track).paddingLeft) || 0) + 1;
      prevBtn.disabled = track.scrollLeft <= edge;
      nextBtn.disabled = track.scrollLeft >= max - edge;
      root.querySelector('.ymal__foot').hidden = max <= 0;
    }
    track.addEventListener('scroll', syncNav, { passive: true });
    window.addEventListener('resize', syncNav);

    addBtn.addEventListener('click', function () {
      var items = cards
        .filter(function (c) { return c.classList.contains('is-selected'); })
        .map(function (c) { return { id: Number(c.dataset.variantId), quantity: 1 }; });
      if (!items.length) return;

      var payload = { items: items };
      var sections = cartSectionIds();
      if (sections.length) {
        payload.sections = sections.join(',');
        payload.sections_url = window.location.pathname;
      }

      addBtn.classList.add('is-busy');
      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(payload)
      })
        .then(function (r) { return r.json().then(function (d) { if (!r.ok) throw d; return d; }); })
        .then(function (data) {
          notifyTheme(items, data);
          syncCrisp();

          var after = root.dataset.afterAdd || 'cart_page';

          // 可靠路径：不碰 DOM，交给整页导航
          if (after === 'cart_page') { window.location.href = window.Shopify.routes.root + 'cart'; return; }
          if (after === 'reload')    { window.location.reload(); return; }
          if (after === 'stay')      return;

          // after === 'drawer'：尽力而为，主题依赖较重，见 schema 里的说明
          function fallback() {
            return softRefreshCart().then(function (ok) { return ok ? 'soft' : 'none'; });
          }
          var swapped = swapSections(data.sections);
          var ready;
          if (swapped.length) {
            reinitSections(swapped);
            ready = Promise.resolve('sections');
          } else {
            var t = themeCartRefresh();
            ready = t ? t.then(function (ok) { return ok ? 'theme' : fallback(); }) : fallback();
          }

          return Promise.resolve(ready).then(function (via) {
            if (isDesign()) console.log('[ymal] cart refresh', { via: via });
            setTimeout(function () {
              if (drawerIsOpen()) return;
              if (!openCartDrawer() && isDesign()) console.warn('[ymal] 找不到抽屉触发器');
            }, 250);
          });
        })
        .catch(function (e) {
          var msg = (e && e.description) || "Couldn't add — try again";
          if (typeof window.showWarning === 'function') {
            try { window.showWarning(msg, window.warningTime); } catch (err) {}
          }
          addLabel.textContent = msg;
          setTimeout(recalc, 2500);
        })
        .finally(function () { addBtn.classList.remove('is-busy'); });
    });

    /* ── 按当前商品的选项预选变体 ──────────────────── */
    function syncToContext(names, values) {
      var ctx = {};
      (names || []).forEach(function (n, i) {
        if (values && values[i]) ctx[norm(n)] = norm(values[i]);
      });
      if (!Object.keys(ctx).length) return;

      cards.forEach(function (card) {
        var select = card.querySelector('[data-ymal-variant]');
        if (!select) return;
        var match = bestOption(select, ctx);
        if (match && match.value !== select.value) {
          select.value = match.value;
          applyOption(card, match);
        }
      });
      recalc();
    }

    // 暴露给 PDP 变体切换时调用
    root.__ymalSync = syncToContext;
    syncToContext(
      (root.dataset.ctxNames || '').split('|'),
      (root.dataset.ctxValues || '').split('|')
    );

    recalc();
    syncNav();
  }

  /* ── 异步拉取 section HTML ───────────────────────── */
  var isDesign = function () { return !!(window.Shopify && window.Shopify.designMode); };

  function bail(root, msg) {
    if (isDesign()) {
      // Theme Editor 里保留 section，把原因显示出来，方便排查
      root.querySelector('[data-ymal-track]').innerHTML =
        '<p style="padding:24px;color:#6B7280;font-size:14px;">' + msg + '</p>';
      root.querySelector('.ymal__foot').hidden = true;
      console.warn('[ymal]', msg, root.dataset.url);
    } else {
      root.remove();
    }
  }

  function load(root, url, allowFallback) {
    fetch(url)
      .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.text(); })
      .then(function (html) {
        var doc = document.createElement('div');
        doc.innerHTML = html;
        var incoming = doc.querySelector('[data-ymal-track]');
        var count = incoming ? incoming.querySelectorAll('.ymal-card:not(.ymal-card--skeleton)').length : 0;

        if (!count) {
          var fb = allowFallback && root.dataset.fallbackUrl;
          if (fb) return load(root, fb, false);
          bail(root, 'No recommendations returned for this product. Check the Search & Discovery setup, or that the products are in stock.');
          return;
        }
        root.querySelector('[data-ymal-track]').innerHTML = incoming.innerHTML;
        init(root);               // innerHTML 注入的 <script> 不会执行，必须手动 init
      })
      .catch(function (e) {
        bail(root, 'Recommendations request failed: ' + e.message);
      });
  }

  function boot() {
    bindJq();
    document.querySelectorAll('.ymal[data-ymal-root]').forEach(function (root) {
      if (root.dataset.ymalBooted === '1') return;
      root.dataset.ymalBooted = '1';

      // Theme Editor 里不做懒加载：section 常在视口外，等不到 IO
      if (isDesign()) { load(root, root.dataset.url, true); return; }

      var io = new IntersectionObserver(function (entries, obs) {
        if (!entries[0].isIntersecting) return;
        obs.disconnect();
        load(root, root.dataset.url, true);
      }, { rootMargin: '0px 0px 400px 0px' });

      io.observe(root);
    });
  }

  /* ── PDP 主商品切换变体时同步 ────────────────────────
     不赌事件名，改为盯"变体 ID"——PDP 上唯一必然会变的东西，它不变加购就是错的。

     线上实测（Ella + Variant Swatch King），点一次颜色实际发生的是：
       history.replaceState → ?variant=<新ID>          ← 路 2 命中
       change 事件 ← 加购表单的 input[name="id"]        ← 路 3 命中
       vsk:product:variant:changed {variantId:"..."}    ← 路 1 命中
     而 variant:change / variant:changed / on:variant:selected / productVariantChange
     这几个通用事件名一个都不派发。之前那版赌事件名的实现就是死在这里，别再改回去。

     三路汇到 applyVariantId()，按 ID 去重，同一次切换只处理一次。
     ID 不在映射表里、或没有卡片打够分，都保持原样不动。
     排查：URL 带 ?ctldebug（或在 Theme Editor 里打开），控制台会打出走的是哪条路。
  ─────────────────────────────────────────────────── */
  var DEBUG;
  function debug() {
    if (DEBUG === undefined) DEBUG = isDesign() || /[?&]ctldebug\b/.test(window.location.search);
    if (DEBUG) console.log.apply(console, ['[ymal]'].concat(Array.prototype.slice.call(arguments)));
  }

  function eachRoot(fn) {
    document.querySelectorAll('.ymal[data-ymal-root]').forEach(fn);
  }

  function variantMap(root) {
    if (!root.__ymalMap) {
      var el = root.querySelector('[data-ymal-variant-map]');
      try { root.__ymalMap = el ? JSON.parse(el.textContent) : {}; }
      catch (e) { root.__ymalMap = {}; }
    }
    return root.__ymalMap;
  }

  /* 先写回 dataset 再同步：section 是懒加载的，用户完全可能在滚到它之前就切了色。
     init() 的初始上下文正是从 dataset 读的，这样那次切换不会被丢掉。 */
  function pushContext(root, values) {
    if (!values || !values.length) return;
    root.dataset.ctxValues = values.join('|');
    if (typeof root.__ymalSync === 'function') {
      root.__ymalSync((root.dataset.ctxNames || '').split('|'), values);
    }
  }

  function variantFromUrl() {
    var m = /[?&]variant=(\d+)/.exec(window.location.search);
    return m ? m[1] : '';
  }

  var lastVariantId = variantFromUrl();

  function applyVariantId(id, via) {
    id = String(id || '').trim();
    if (!id || id === lastVariantId) return;
    lastVariantId = id;
    eachRoot(function (root) {
      var opts = variantMap(root)[id];
      debug('variant', id, 'via', via, '→', opts || '不在映射表里，卡片保持原样');
      if (opts) pushContext(root, opts);
    });
  }

  // 路 1：主题自定义事件
  function onPdpVariant(e) {
    var v = e && e.detail && (e.detail.variant || e.detail);
    if (!v) return;
    var id = v.id || v.variantId;                 // Swatch King 给的键名是 variantId
    if (id) { applyVariantId(id, e.type); return; }
    var opts = v.options || v.option_values;      // 有的主题只给选项值不给 id
    if (!opts || !opts.length) return;
    lastVariantId = '';
    debug('options', opts, 'via', e.type);
    eachRoot(function (root) { pushContext(root, opts); });
  }

  // 路 2：URL
  function watchUrl() {
    ['pushState', 'replaceState'].forEach(function (name) {
      var orig = history[name];
      if (typeof orig !== 'function') return;
      history[name] = function () {
        var r = orig.apply(this, arguments);
        try { applyVariantId(variantFromUrl(), 'url:' + name); } catch (err) {}
        return r;
      };
    });
    window.addEventListener('popstate', function () {
      applyVariantId(variantFromUrl(), 'url:popstate');
    });
  }

  // 路 3：加购表单里的变体域
  var ID_SEL = 'input[name="id"],select[name="id"]';
  function fromVariantField(el) {
    if (!el || !el.value) return;
    var form = el.form || (el.closest && el.closest('form'));
    var action = form && form.getAttribute('action');
    if (action && !/\/cart\/add/.test(action)) return;   // 别撞上页面上无关的 name="id"
    applyVariantId(el.value, 'field');
  }

  /* Ella 是 jQuery 主题：$(el).val(id).trigger('change') 走 jQuery 自己的事件系统，
     原生 addEventListener 收不到。所以两边都要挂委托监听。 */
  var jqBound = false;
  function bindJq() {
    if (jqBound || !window.jQuery) return;
    jqBound = true;
    window.jQuery(document).on('change', ID_SEL, function () { fromVariantField(this); });
  }

  ['vsk:product:variant:changed',                 // 实测存在（Variant Swatch King）
   'variant:change', 'variant:changed', 'on:variant:selected', 'productVariantChange']
    .forEach(function (n) { document.addEventListener(n, onPdpVariant); });
  document.addEventListener('change', function (e) {
    if (e.target && e.target.matches && e.target.matches(ID_SEL)) fromVariantField(e.target);
  }, true);
  watchUrl();
  bindJq();
  window.addEventListener('load', bindJq);   // jQuery 可能比本脚本晚加载

  document.addEventListener('DOMContentLoaded', boot);
  // Theme editor 里重新渲染 section 后重新绑定
  document.addEventListener('shopify:section:load', boot);
  if (document.readyState !== 'loading') boot();
})();

  } catch(e) { console.error(e); }
})();
})();
